var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWebsiteCreator(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M407.68,262.82c-88-50.83-230.31-50.83-317.77,0s-87,133.24,1,184.07,230.31,50.83,317.78,0S495.72,313.65,407.68,262.82Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229.69,403.48c-19.25-11.11-50.35-11.11-69.48,0s-19,29.13.23,40.24,50.35,11.12,69.48,0S248.94,414.59,229.69,403.48Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.59,338.72c-20.48-11.83-53.58-11.83-73.93,0-18,10.45-20,26.63-6.08,38.42-11.22-.7-22.85,1.44-31.42,6.42-15,8.74-15,22.91.18,31.65s39.6,8.74,54.64,0c12-7,14.35-17.34,7.21-25.7,17.24,2.49,36.22-.16,49.65-8C445.19,369.72,445.08,350.55,424.59,338.72Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.81,266.16,300,257.63a15,15,0,0,0-14.94,0l-82,47.54L195.82,301l-59.38,34.75,6.85,3.94-97.1,56.07a5,5,0,0,0,0,8.63L61.13,413a15,15,0,0,0,15,0l97-56.13,11.34,6.54a29.9,29.9,0,0,0,29.87,0l34.88-20.14a6.64,6.64,0,0,0,0-11.51l-16.35-9.41,13.77-8,4.78-2.77,63.4-36.79A5,5,0,0,0,314.81,266.16Z",
    style: {
      fill: "#e6e6e6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M237.14,334.22,208.7,350.5a27,27,0,0,1-26.85-.05l-21.11-12.16a8.11,8.11,0,0,1-4.05-7l0-14.39-4.4,2.54V332a9.42,9.42,0,0,0,4.73,8.18l25.05,14.44a26.53,26.53,0,0,0,26.44,0l28.65-16.39a10.72,10.72,0,0,0,5.23-11.36A10.65,10.65,0,0,1,237.14,334.22Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.14,334.22,208.7,350.5a27,27,0,0,1-26.85-.05l-21.11-12.16a8.11,8.11,0,0,1-4.05-7l0-14.39-4.4,2.54V332a9.42,9.42,0,0,0,4.73,8.18l25.05,14.44a26.53,26.53,0,0,0,26.44,0l28.65-16.39a10.72,10.72,0,0,0,5.23-11.36A10.65,10.65,0,0,1,237.14,334.22Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.74,338.29l21.11,12.16a27,27,0,0,0,26.85.05l28.44-16.28a10.65,10.65,0,0,0,5.23-7.36,10.65,10.65,0,0,0-5-7.25l-23.33-14a9.45,9.45,0,0,1-4.58-8.1V286.41L156.67,316.9l0,14.39A8.11,8.11,0,0,0,160.74,338.29Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.74,338.29a8.11,8.11,0,0,1-4.05-7l0-14.39-4.4,2.54V332a9.42,9.42,0,0,0,4.73,8.18l8.89,5.12v-4Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.74,338.29l5.15,3h0L221,309.78,214,305.62a9.45,9.45,0,0,1-4.58-8.1V286.41L156.67,316.9l0,14.39A8.11,8.11,0,0,0,160.74,338.29Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.52,374.13h0l-.06,0Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65,368.87l-.4-180.38c0-5.12,3.58-11.36,8-13.94L296.88,45.43c2.21-1.28,4.22-1.4,5.69-.58L294.12,40h0c-1.47-.94-3.55-.86-5.86.47L64.05,169.55c-4.47,2.58-8.07,8.82-8,13.94l.4,180.38c0,2.42.83,4.14,2.15,5h0a3.3,3.3,0,0,0,.45.26L67.34,374C65.91,373.17,65,371.39,65,368.87Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.12,40h0c-1.47-.94-3.55-.86-5.86.47L64.05,169.55a16.86,16.86,0,0,0-6.17,6.88l8.63,5a16.89,16.89,0,0,1,6.15-6.86L296.88,45.43c2.21-1.28,4.22-1.4,5.69-.58Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56,183.49l.4,180.38c0,2.42.83,4.14,2.15,5h0a3.3,3.3,0,0,0,.45.26L67.34,374c-1.43-.85-2.31-2.63-2.32-5.15l-.4-180.38a15.71,15.71,0,0,1,1.89-7.08l-8.63-5A15.74,15.74,0,0,0,56,183.49Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.66,44.9l0,0,0,0Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305,50.05c0-2.52-.9-4.29-2.32-5.15l0,0-.05,0c-1.47-.82-3.48-.7-5.69.58L72.66,174.55c-4.46,2.58-8.06,8.82-8,13.94L65,368.87c0,2.52.89,4.3,2.32,5.15l.12.07.06,0c1.46.77,3.43.62,5.6-.63L297.34,244.37c4.45-2.57,8.06-8.82,8-13.94ZM293.35,237.47,73,364.37l-.4-175.9a10.08,10.08,0,0,1,4.07-7L297,54.55l.4,175.9A10.08,10.08,0,0,1,293.35,237.47Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297,54.55l-5.7,3.29.38,169.83a10,10,0,0,1-4.07,7L73,358.3l0,6.07,220.37-126.9a10.08,10.08,0,0,0,4.07-7Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297,54.55l-5.7,3.29.38,169.83a10,10,0,0,1-4.07,7L73,358.3l0,6.07,220.37-126.9a10.08,10.08,0,0,0,4.07-7Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.7,227.67l-.38-169.83L76.65,181.45a10.08,10.08,0,0,0-4.07,7L73,358.3,287.63,234.68A10,10,0,0,0,291.7,227.67Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Windows--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99,378,98.61,207.5a16.79,16.79,0,0,1,7.61-13.18l211.92-122c2.09-1.21,4-1.33,5.38-.55l-8-4.63h0c-1.4-.89-3.37-.81-5.55.45L98.07,189.6a16.72,16.72,0,0,0-7.6,13.17l.38,170.49c0,2.28.78,3.92,2,4.76h0a3.58,3.58,0,0,0,.42.25l7.87,4.58C99.84,382.05,99,380.37,99,378Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.54,67.1h0c-1.4-.89-3.37-.81-5.55.45L98.07,189.6a16,16,0,0,0-5.83,6.49l8.16,4.71a15.94,15.94,0,0,1,5.82-6.48l211.92-122c2.09-1.21,4-1.33,5.38-.55Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.47,202.77l.38,170.49c0,2.28.78,3.92,2,4.76h0a3.58,3.58,0,0,0,.42.25l7.87,4.58c-1.34-.8-2.18-2.48-2.19-4.86L98.61,207.5a15.07,15.07,0,0,1,1.79-6.7l-8.16-4.71A15,15,0,0,0,90.47,202.77Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.63,217.38,99,378c0,2.38.85,4.06,2.19,4.86l.12.07.06,0c1.38.72,3.24.59,5.29-.6l211.92-122a16.8,16.8,0,0,0,7.61-13.18l-.36-160.87Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.63,217.38,99,378c0,2.38.85,4.06,2.19,4.86l.12.07.06,0c1.38.72,3.24.59,5.29-.6l211.92-122a16.8,16.8,0,0,0,7.61-13.18l-.36-160.87Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317,97c2-1.13,3.56-.23,3.57,2a7.81,7.81,0,0,1-3.55,6.14l-181.66,105c-2,1.13-3.57.22-3.57-2a7.82,7.82,0,0,1,3.55-6.15Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M317,97c2-1.13,3.56-.23,3.57,2a7.81,7.81,0,0,1-3.55,6.14l-181.66,105c-2,1.13-3.57.22-3.57-2a7.82,7.82,0,0,1,3.55-6.15Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M108.68,219.22a.27.27,0,0,1,.24,0c.15.07.16.33,0,.57l-1.15,2.11,3.87-2.23c.2-.12.36,0,.36.2a.78.78,0,0,1-.36.62l-3.87,2.24,1.16.78c.13.09.12.35,0,.59a.83.83,0,0,1-.24.25.29.29,0,0,1-.27,0l-1.71-1.16a.27.27,0,0,1-.07-.08.68.68,0,0,1,0-.14.77.77,0,0,1,0-.15.67.67,0,0,1,.07-.17l1.7-3.13A.65.65,0,0,1,108.68,219.22Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.46,213.57a.25.25,0,0,1,.27,0l1.71,1.15a.31.31,0,0,1,.07.09.69.69,0,0,1,0,.13.77.77,0,0,1,0,.15.67.67,0,0,1-.07.17l-1.7,3.13a.83.83,0,0,1-.26.29.29.29,0,0,1-.25,0c-.14-.07-.15-.32,0-.57l1.15-2.11-3.87,2.24c-.2.11-.36,0-.36-.21a.81.81,0,0,1,.36-.62l3.87-2.23-1.16-.78c-.13-.09-.12-.36,0-.59A.72.72,0,0,1,118.46,213.57Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.62,209.44a1.81,1.81,0,0,1,1.19-.29.77.77,0,0,1,.35-.56h0c.19-.1.35,0,.34.23l0,.92a.82.82,0,0,1-.34.59l-.78.49h0c-.19.11-.35,0-.36-.19a.8.8,0,0,1,.28-.58,1.49,1.49,0,0,0-.65.21,3.31,3.31,0,0,0-1.5,2.59c0,1,.68,1.33,1.51.85A3.23,3.23,0,0,0,127,212a.73.73,0,0,1,.31-.39.3.3,0,0,1,.17-.05c.18,0,.24.22.15.47a4.83,4.83,0,0,1-2,2.46c-1.22.7-2.22.13-2.22-1.27A4.88,4.88,0,0,1,125.62,209.44Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.68,219.22a.27.27,0,0,1,.24,0c.15.07.16.33,0,.57l-1.15,2.11,3.87-2.23c.2-.12.36,0,.36.2a.78.78,0,0,1-.36.62l-3.87,2.24,1.16.78c.13.09.12.35,0,.59a.83.83,0,0,1-.24.25.29.29,0,0,1-.27,0l-1.71-1.16a.27.27,0,0,1-.07-.08.68.68,0,0,1,0-.14.77.77,0,0,1,0-.15.67.67,0,0,1,.07-.17l1.7-3.13A.65.65,0,0,1,108.68,219.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.46,213.57a.25.25,0,0,1,.27,0l1.71,1.15a.31.31,0,0,1,.07.09.69.69,0,0,1,0,.13.77.77,0,0,1,0,.15.67.67,0,0,1-.07.17l-1.7,3.13a.83.83,0,0,1-.26.29.29.29,0,0,1-.25,0c-.14-.07-.15-.32,0-.57l1.15-2.11-3.87,2.24c-.2.11-.36,0-.36-.21a.81.81,0,0,1,.36-.62l3.87-2.23-1.16-.78c-.13-.09-.12-.36,0-.59A.72.72,0,0,1,118.46,213.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.62,209.44a1.81,1.81,0,0,1,1.19-.29.77.77,0,0,1,.35-.56h0c.19-.1.35,0,.34.23l0,.92a.82.82,0,0,1-.34.59l-.78.49h0c-.19.11-.35,0-.36-.19a.8.8,0,0,1,.28-.58,1.49,1.49,0,0,0-.65.21,3.31,3.31,0,0,0-1.5,2.59c0,1,.68,1.33,1.51.85A3.23,3.23,0,0,0,127,212a.73.73,0,0,1,.31-.39.3.3,0,0,1,.17-.05c.18,0,.24.22.15.47a4.83,4.83,0,0,1-2,2.46c-1.22.7-2.22.13-2.22-1.27A4.88,4.88,0,0,1,125.62,209.44Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M189.7,300.51l125.48-72.4a2.18,2.18,0,0,1,3.27,1.89v15.75a5.45,5.45,0,0,1-2.73,4.72L190.23,323a2.19,2.19,0,0,1-3.28-1.89l0-15.85A5.46,5.46,0,0,1,189.7,300.51Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.1,134.05l0-15.82a2.18,2.18,0,0,0-3.27-1.88L189.69,187a5.46,5.46,0,0,0-2.74,4.73V208a2.19,2.19,0,0,0,3.28,1.89l123.15-71.1A5.45,5.45,0,0,0,316.1,134.05Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.67 154.74 273.67 157.21 194.13 203.13 194.12 200.67 273.67 154.74",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.65 150.19 273.66 152.64 194.11 198.57 194.11 196.11 273.65 150.19",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "238.8 165.18 238.81 167.65 194.1 193.46 194.09 191 238.8 165.18",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "304.95 131.84 304.96 134.3 290.81 142.47 290.8 140 304.95 131.84",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.65,126.59c2.91-1.68,5.28-.34,5.29,3a11.61,11.61,0,0,1-5.26,9.12l-15.56,9c-2.92,1.69-5.29.34-5.3-3a11.57,11.57,0,0,1,5.26-9.11ZM305,134.3v-2.46L290.8,140v2.46L305,134.3",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.25,252.12,314.08,221a8.74,8.74,0,0,0,4.37-7.56V149.59a3.27,3.27,0,0,0-4.91-2.83L259.7,177.84a8.73,8.73,0,0,0-4.36,7.56v63.88A3.28,3.28,0,0,0,260.25,252.12Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.18,190.46l1.79-1a.25.25,0,0,0,.09-.34.25.25,0,0,0-.35-.1l-1.79,1a.26.26,0,0,0,.13.48A.33.33,0,0,0,283.18,190.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.22,195.6l1.79-1a.25.25,0,1,0-.25-.44l-1.79,1a.26.26,0,0,0-.1.35.26.26,0,0,0,.22.12A.28.28,0,0,0,274.22,195.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.27,200.74l1.79-1a.26.26,0,0,0-.26-.44l-1.79,1a.26.26,0,0,0-.09.35.25.25,0,0,0,.22.12A.31.31,0,0,0,265.27,200.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.74,198.17l1.79-1a.25.25,0,0,0,.1-.35.26.26,0,0,0-.35-.09l-1.79,1a.26.26,0,0,0-.09.35.24.24,0,0,0,.22.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.7,193l1.79-1a.25.25,0,0,0,.09-.34.24.24,0,0,0-.34-.1l-1.79,1a.25.25,0,0,0,.12.47A.28.28,0,0,0,278.7,193Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.57,177.61l1.79-1a.26.26,0,0,0,.09-.35.25.25,0,0,0-.35-.1l-1.79,1a.26.26,0,0,0,.13.48A.22.22,0,0,0,305.57,177.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.13,185.32l1.79-1a.24.24,0,0,0,.1-.34.25.25,0,0,0-.35-.1l-1.79,1a.26.26,0,0,0-.09.35.25.25,0,0,0,.22.13A.28.28,0,0,0,292.13,185.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.09,180.18l1.79-1a.25.25,0,0,0,.09-.34.24.24,0,0,0-.34-.1l-1.8,1a.26.26,0,0,0,.13.48A.22.22,0,0,0,301.09,180.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.92,175.08a.19.19,0,0,0,.12,0l1.8-1a.26.26,0,0,0,.09-.35.25.25,0,0,0-.35-.1l-1.79,1a.26.26,0,0,0-.09.35A.25.25,0,0,0,309.92,175.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.61,182.75l1.79-1a.25.25,0,0,0,.1-.34.25.25,0,0,0-.35-.1l-1.79,1a.26.26,0,0,0-.1.35.27.27,0,0,0,.22.13A.2.2,0,0,0,296.61,182.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.53,185.86a.25.25,0,0,0-.25-.25.26.26,0,0,0-.26.25v2a.26.26,0,0,0,.26.25.25.25,0,0,0,.25-.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.53,180.82a.25.25,0,0,0-.25-.25.26.26,0,0,0-.26.25v2a.26.26,0,0,0,.26.25.25.25,0,0,0,.25-.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.53,190.9a.26.26,0,0,0-.25-.26.26.26,0,0,0-.26.26v2a.26.26,0,0,0,.26.26.26.26,0,0,0,.25-.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.53,195.94a.25.25,0,0,0-.25-.26.26.26,0,0,0-.26.26v2a.26.26,0,0,0,.26.26.26.26,0,0,0,.25-.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.53,201a.25.25,0,0,0-.25-.25.26.26,0,0,0-.26.25v2a.26.26,0,0,0,.26.25.25.25,0,0,0,.25-.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.28,205.76a.26.26,0,0,0-.26.25v2a.26.26,0,0,0,.26.26.25.25,0,0,0,.25-.26v-2A.25.25,0,0,0,315.28,205.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.53,175.79a.26.26,0,0,0-.25-.26.26.26,0,0,0-.26.26v2a.26.26,0,0,0,.26.26.26.26,0,0,0,.25-.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.74,224.19l-1.78,1a.25.25,0,0,0-.1.35.26.26,0,0,0,.22.13.2.2,0,0,0,.13,0l1.79-1a.26.26,0,0,0-.26-.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267,239.63l-1.78,1a.26.26,0,0,0-.09.35.25.25,0,0,0,.22.13.19.19,0,0,0,.12,0l1.79-1a.25.25,0,0,0,.09-.34A.25.25,0,0,0,267,239.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.43,237.06l-1.79,1a.26.26,0,0,0-.09.35.25.25,0,0,0,.22.12.31.31,0,0,0,.13,0l1.78-1a.25.25,0,1,0-.25-.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.13,216.47l-1.79,1a.26.26,0,0,0,.13.48.22.22,0,0,0,.13,0l1.78-1a.25.25,0,1,0-.25-.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.35,231.91l-1.78,1a.26.26,0,0,0-.1.35.27.27,0,0,0,.22.13.2.2,0,0,0,.13,0l1.79-1a.25.25,0,0,0,.09-.34A.25.25,0,0,0,280.35,231.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.67,219l-1.79,1a.26.26,0,0,0-.09.35.25.25,0,0,0,.22.13l.13,0,1.78-1a.26.26,0,0,0,.09-.35A.25.25,0,0,0,302.67,219Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.82,229.34l-1.79,1a.26.26,0,0,0-.09.35.24.24,0,0,0,.22.12.27.27,0,0,0,.12,0l1.79-1a.26.26,0,0,0,.09-.35A.25.25,0,0,0,284.82,229.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.59,213.9l-1.78,1a.25.25,0,0,0-.1.35.26.26,0,0,0,.22.12.28.28,0,0,0,.13,0l1.79-1a.26.26,0,1,0-.26-.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.2,221.62l-1.78,1a.26.26,0,0,0-.1.35.27.27,0,0,0,.23.12l.12,0,1.79-1a.26.26,0,1,0-.26-.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.89,234.49l-1.79,1a.25.25,0,0,0-.09.34.24.24,0,0,0,.22.13.28.28,0,0,0,.13,0l1.78-1a.25.25,0,0,0,.1-.35A.26.26,0,0,0,275.89,234.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.65,221.49h0a.25.25,0,0,0-.25.25v2a.25.25,0,0,0,.25.25h0a.26.26,0,0,0,.26-.25v-2A.26.26,0,0,0,261.65,221.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.68,226.53h0a.26.26,0,0,0-.25.26v2a.25.25,0,0,0,.25.25h0a.26.26,0,0,0,.26-.26v-2A.26.26,0,0,0,261.68,226.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.59,206.36h0a.25.25,0,0,0-.25.25v2a.25.25,0,0,0,.25.25h0a.25.25,0,0,0,.25-.25v-2A.25.25,0,0,0,261.59,206.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.72,236.62a.24.24,0,0,0-.25.25v2a.26.26,0,0,0,.26.26h0a.26.26,0,0,0,.25-.26v-2a.25.25,0,0,0-.25-.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.61,211.4h0a.26.26,0,0,0-.26.26v2a.26.26,0,0,0,.26.26h0a.26.26,0,0,0,.25-.26v-2A.25.25,0,0,0,261.61,211.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.63,216.45h0a.25.25,0,0,0-.25.25v2a.26.26,0,0,0,.26.25h0a.25.25,0,0,0,.25-.25v-2A.26.26,0,0,0,261.63,216.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.7,231.58h0a.26.26,0,0,0-.26.25v2a.26.26,0,0,0,.26.25h0a.25.25,0,0,0,.25-.25v-2A.25.25,0,0,0,261.7,231.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.1,200.08a.23.23,0,0,0-.25,0l-3,1.71a.25.25,0,0,0-.13.22v3.4a.25.25,0,0,0,.13.22.19.19,0,0,0,.12,0,.2.2,0,0,0,.13,0l3-1.71a.25.25,0,0,0,.13-.22v-3.4A.25.25,0,0,0,264.1,200.08Zm-.38.66v2.81L261.28,205v-2.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290,185.05a.24.24,0,0,0-.26,0l-3,1.71a.25.25,0,0,0-.13.22v3.4a.25.25,0,0,0,.13.22.2.2,0,0,0,.13,0,.19.19,0,0,0,.12,0l3-1.71a.26.26,0,0,0,.12-.22v-3.4A.26.26,0,0,0,290,185.05Zm-.38.66v2.82l-2.45,1.41v-2.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.44,176.38a.3.3,0,0,0,.26,0l3-1.71a.26.26,0,0,0,.13-.22V171a.26.26,0,0,0-.13-.22.28.28,0,0,0-.25,0l-3,1.71a.27.27,0,0,0-.12.22v3.41A.27.27,0,0,0,312.44,176.38Zm2.83-4.9v2.82l-2.46,1.42V172.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.1,239.35a.23.23,0,0,0-.25,0l-3,1.71a.26.26,0,0,0-.13.22v3.41a.26.26,0,0,0,.13.22l.12,0a.28.28,0,0,0,.13,0l3-1.71a.26.26,0,0,0,.13-.23v-3.4A.26.26,0,0,0,264.1,239.35Zm-.38.66v2.82l-2.45,1.41v-2.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290,224.32a.3.3,0,0,0-.26,0l-3,1.71a.26.26,0,0,0-.13.22v3.41a.26.26,0,0,0,.13.22.28.28,0,0,0,.13,0,.27.27,0,0,0,.12,0l3-1.71a.28.28,0,0,0,.12-.23v-3.4A.27.27,0,0,0,290,224.32Zm-.38.66v2.82l-2.45,1.41V226.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.65,210.1a.23.23,0,0,0-.25,0l-3,1.71a.26.26,0,0,0-.12.22v3.4a.26.26,0,0,0,.12.22.23.23,0,0,0,.26,0l3-1.71a.25.25,0,0,0,.13-.22v-3.4A.25.25,0,0,0,315.65,210.1Zm-.38.66v2.81L312.82,215v-2.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "314.05 163.32 314.06 165.79 261 196.21 260.99 193.74 314.05 163.32",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "314.04 158.77 314.05 161.23 260.98 191.65 260.98 189.19 314.04 158.77",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "281.98 171.91 281.99 174.38 260.97 186.54 260.96 184.07 281.98 171.91",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178,193.68l-66.25,38a6.53,6.53,0,0,0-3.29,5.69l.21,95.15a2.19,2.19,0,0,0,3.28,1.89L178,296.34a6.57,6.57,0,0,0,3.27-5.68V195.57A2.18,2.18,0,0,0,178,193.68Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.29,225l1.92-1.1a.28.28,0,1,0-.28-.48L139,224.57a.27.27,0,0,0-.1.37.26.26,0,0,0,.23.13A.35.35,0,0,0,139.29,225Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.69,230.54l1.92-1.1a.27.27,0,0,0-.27-.47l-1.92,1.1a.28.28,0,0,0-.1.37.27.27,0,0,0,.24.14A.22.22,0,0,0,129.69,230.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.1,236.05,122,235a.27.27,0,0,0,.1-.37.27.27,0,0,0-.37-.11l-1.92,1.11a.27.27,0,0,0-.1.37.26.26,0,0,0,.24.13A.31.31,0,0,0,120.1,236.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.9,233.3l1.92-1.11a.27.27,0,0,0,.1-.37.29.29,0,0,0-.38-.1l-1.91,1.1a.27.27,0,0,0,.13.51A.35.35,0,0,0,124.9,233.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.49,227.79l1.92-1.1a.27.27,0,0,0-.27-.47l-1.92,1.1a.27.27,0,0,0-.1.37.27.27,0,0,0,.24.14A.22.22,0,0,0,134.49,227.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.27,211.28l1.92-1.11a.27.27,0,0,0,.1-.37.28.28,0,0,0-.37-.1L163,210.8a.27.27,0,0,0,.13.51A.32.32,0,0,0,163.27,211.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.88,219.53l1.92-1.1a.27.27,0,0,0-.27-.47l-1.92,1.1a.27.27,0,0,0-.1.37.27.27,0,0,0,.24.14A.22.22,0,0,0,148.88,219.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.47,214l1.92-1.1a.28.28,0,0,0,.1-.38.27.27,0,0,0-.37-.1l-1.92,1.1a.29.29,0,0,0-.1.38.28.28,0,0,0,.24.13A.31.31,0,0,0,158.47,214Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.93,208.56a.25.25,0,0,0,.14,0l1.92-1.1a.27.27,0,0,0,.1-.37.28.28,0,0,0-.38-.1l-1.91,1.1a.27.27,0,0,0,.13.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.68,216.78l1.92-1.1a.27.27,0,1,0-.28-.47l-1.91,1.1a.27.27,0,0,0,.13.51A.37.37,0,0,0,153.68,216.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174,220.11a.28.28,0,0,0-.55,0v2.16a.28.28,0,0,0,.55,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174,214.72a.28.28,0,1,0-.55,0v2.15a.28.28,0,1,0,.55,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174,225.51a.28.28,0,1,0-.55,0v2.15a.28.28,0,1,0,.55,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174,230.9a.28.28,0,0,0-.55,0v2.16a.28.28,0,0,0,.55,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174,236.3a.28.28,0,1,0-.55,0v2.16a.28.28,0,0,0,.55,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.67,241.42a.27.27,0,0,0-.27.27v2.16a.28.28,0,0,0,.55,0v-2.16A.27.27,0,0,0,173.67,241.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174,209.32a.28.28,0,0,0-.55,0v2.16a.28.28,0,0,0,.55,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.6,261.17l-1.91,1.1a.29.29,0,0,0-.1.38.28.28,0,0,0,.24.13.31.31,0,0,0,.13,0l1.92-1.11a.27.27,0,0,0,.1-.37A.28.28,0,0,0,150.6,261.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.92,277.71l-1.91,1.1a.27.27,0,0,0,.13.51.32.32,0,0,0,.14,0l1.91-1.11a.27.27,0,0,0,.1-.37A.27.27,0,0,0,121.92,277.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.7,275l-1.91,1.11a.27.27,0,0,0-.1.37.27.27,0,0,0,.24.14.33.33,0,0,0,.13,0l1.91-1.1a.28.28,0,0,0,.1-.38A.27.27,0,0,0,126.7,275Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.94,252.9,163,254a.29.29,0,0,0-.1.38.28.28,0,0,0,.24.13.31.31,0,0,0,.13,0l1.92-1.11a.27.27,0,0,0,.1-.37A.29.29,0,0,0,164.94,252.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.26,269.44l-1.91,1.1a.28.28,0,0,0-.1.38.28.28,0,0,0,.24.13.31.31,0,0,0,.13,0l1.91-1.11a.27.27,0,0,0-.27-.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.16,255.66l-1.91,1.1a.28.28,0,0,0-.1.37.27.27,0,0,0,.24.14.22.22,0,0,0,.13,0l1.92-1.1a.27.27,0,1,0-.28-.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141,266.68l-1.91,1.11a.27.27,0,0,0-.1.37.27.27,0,0,0,.24.14.33.33,0,0,0,.13,0l1.92-1.1a.28.28,0,1,0-.28-.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.72,250.14l-1.91,1.11a.27.27,0,0,0-.1.37.27.27,0,0,0,.24.14.43.43,0,0,0,.14,0l1.91-1.1a.28.28,0,1,0-.28-.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.38,258.41l-1.91,1.11a.27.27,0,0,0-.1.37.27.27,0,0,0,.24.14.33.33,0,0,0,.13,0l1.92-1.1a.28.28,0,1,0-.28-.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.48,272.2l-1.91,1.1a.27.27,0,0,0,.14.51.22.22,0,0,0,.13,0l1.91-1.1a.27.27,0,0,0-.27-.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.23,258.27h0a.28.28,0,0,0-.27.28v2.16a.27.27,0,0,0,.27.27h0a.27.27,0,0,0,.27-.27v-2.16A.28.28,0,0,0,116.23,258.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.25,263.68h0a.27.27,0,0,0-.27.27v2.16a.27.27,0,0,0,.27.27h0a.27.27,0,0,0,.27-.27V264A.27.27,0,0,0,116.25,263.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.16,242.07h0a.27.27,0,0,0-.27.27v2.16a.27.27,0,0,0,.27.27h0a.27.27,0,0,0,.27-.27v-2.16A.27.27,0,0,0,116.16,242.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.3,274.48a.28.28,0,0,0-.27.28v2.16a.27.27,0,0,0,.27.27h0a.27.27,0,0,0,.27-.28v-2.16a.28.28,0,0,0-.28-.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.18,247.47h0a.27.27,0,0,0-.27.27v2.16a.28.28,0,0,0,.27.28h0a.29.29,0,0,0,.28-.28v-2.16A.28.28,0,0,0,116.18,247.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.21,252.87h0a.29.29,0,0,0-.28.28v2.16a.28.28,0,0,0,.28.27h0a.28.28,0,0,0,.27-.28v-2.16A.27.27,0,0,0,116.21,252.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.28,269.08h0a.26.26,0,0,0-.27.27v2.16a.28.28,0,0,0,.27.28h0a.28.28,0,0,0,.27-.28v-2.16A.27.27,0,0,0,116.28,269.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.85,235.34a.26.26,0,0,0-.27,0l-3.17,1.83a.27.27,0,0,0-.14.24v3.64a.29.29,0,0,0,.14.24.25.25,0,0,0,.27,0l3.18-1.83a.28.28,0,0,0,.13-.24v-3.65A.27.27,0,0,0,118.85,235.34Zm-.4.71v3l-2.63,1.52v-3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.62,219.24a.26.26,0,0,0-.27,0l-3.17,1.83a.27.27,0,0,0-.14.24V225a.27.27,0,0,0,.14.24.25.25,0,0,0,.27,0l3.17-1.83a.27.27,0,0,0,.14-.24v-3.64A.27.27,0,0,0,146.62,219.24Zm-.4.71v3l-2.62,1.52v-3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.64,210a.22.22,0,0,0,.13,0,.23.23,0,0,0,.14,0l3.17-1.83a.27.27,0,0,0,.14-.24v-3.64a.27.27,0,0,0-.14-.24.26.26,0,0,0-.27,0l-3.17,1.83a.27.27,0,0,0-.14.24v3.65A.25.25,0,0,0,170.64,210Zm3-5.24v3l-2.62,1.52v-3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.85,277.41a.26.26,0,0,0-.27,0l-3.17,1.83a.27.27,0,0,0-.14.24v3.64a.29.29,0,0,0,.14.24.25.25,0,0,0,.27,0l3.18-1.83a.28.28,0,0,0,.13-.24v-3.65A.27.27,0,0,0,118.85,277.41Zm-.4.71v3l-2.63,1.52v-3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.62,261.31a.26.26,0,0,0-.27,0l-3.17,1.83a.27.27,0,0,0-.14.24V267a.27.27,0,0,0,.14.24.25.25,0,0,0,.27,0l3.17-1.83a.27.27,0,0,0,.14-.24v-3.65A.27.27,0,0,0,146.62,261.31Zm-.4.71v3l-2.62,1.52v-3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.07,246.07a.26.26,0,0,0-.27,0l-3.17,1.83a.27.27,0,0,0-.14.24v3.65a.27.27,0,0,0,.14.23.22.22,0,0,0,.13,0,.23.23,0,0,0,.14,0l3.17-1.83a.27.27,0,0,0,.14-.24v-3.64A.27.27,0,0,0,174.07,246.07Zm-.4.71v3l-2.62,1.51v-3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "174.22 263.93 174.23 266.4 116.04 300.28 116.03 297.82 174.22 263.93",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "174.21 259.38 174.22 261.83 116.02 295.72 116.02 293.26 174.21 259.38",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "174.22 273.21 174.23 275.67 116.04 309.56 116.03 307.09 174.22 273.21",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "174.21 268.65 174.22 271.11 116.02 305 116.02 302.54 174.21 268.65",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "149.78 296.91 149.79 299.38 116.04 319.02 116.03 316.56 149.78 296.91",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "174.21 278.12 174.22 280.57 116.02 314.46 116.02 312 174.21 278.12",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "131.12 279.25 131.13 281.72 116.01 290.61 116 288.15 131.12 279.25",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.86,291.13l53.84-31.08a8.73,8.73,0,0,0,4.36-7.56V188.61a3.28,3.28,0,0,0-4.91-2.84l-53.83,31.08a8.75,8.75,0,0,0-4.37,7.57v63.87A3.28,3.28,0,0,0,191.86,291.13Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "219.77 263.48 219.78 265.95 192.75 281.5 192.74 279.04 219.77 263.48",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "245.79 244.06 245.79 246.52 192.73 276.94 192.72 274.48 245.79 244.06",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "232.73 246.1 232.74 248.56 192.72 271.83 192.71 269.36 232.73 246.1",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "229.22 229.32 237.63 224.46 229.24 238.97 229.22 229.32",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "237.56 202.45 237.63 224.46 229.22 229.32 229.24 238.97 237.63 224.46 229.24 238.97 199.48 256.16 199.39 224.49 237.56 202.45",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.8,76.64c0-2.38-.85-4-2.2-4.86l0,0-.05,0c-1.39-.78-3.29-.66-5.38.55l-211.92,122a16.79,16.79,0,0,0-7.61,13.18l0,9.88L325.82,86.26Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.8,76.64c0-2.38-.85-4-2.2-4.86l0,0-.05,0c-1.39-.78-3.29-.66-5.38.55l-211.92,122a16.79,16.79,0,0,0-7.61,13.18l0,9.88L325.82,86.26Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.7,201.23c1.15-.66,2.09-.13,2.09,1.19a4.59,4.59,0,0,1-2.07,3.59c-1.15.67-2.09.13-2.09-1.19A4.55,4.55,0,0,1,108.7,201.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.39,198c1.14-.66,2.08-.13,2.08,1.19a4.54,4.54,0,0,1-2.07,3.59c-1.15.67-2.08.13-2.09-1.19A4.58,4.58,0,0,1,114.39,198Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.07,194.67c1.15-.66,2.08-.13,2.09,1.19a4.58,4.58,0,0,1-2.08,3.59c-1.15.66-2.08.13-2.09-1.19A4.58,4.58,0,0,1,120.07,194.67Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M108.7,201.23c1.15-.66,2.09-.13,2.09,1.19a4.59,4.59,0,0,1-2.07,3.59c-1.15.67-2.09.13-2.09-1.19A4.55,4.55,0,0,1,108.7,201.23Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.39,198c1.14-.66,2.08-.13,2.08,1.19a4.54,4.54,0,0,1-2.07,3.59c-1.15.67-2.08.13-2.09-1.19A4.58,4.58,0,0,1,114.39,198Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.07,194.67c1.15-.66,2.08-.13,2.09,1.19a4.58,4.58,0,0,1-2.08,3.59c-1.15.66-2.08.13-2.09-1.19A4.58,4.58,0,0,1,120.07,194.67Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.36,383h0l-.06,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.61,71.78l0,0,0,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.8,76.64c0-2.38-.85-4-2.2-4.86l0,0-.05,0a4,4,0,0,0-1.76-.49,4,4,0,0,1,1.76.49l-8-4.63h0c-1.4-.89-3.37-.81-5.55.45L98.07,189.6c-.28.16-.55.34-.83.53l-.25.19c-.18.13-.37.27-.55.42l-.28.25c-.17.14-.33.29-.5.45l-.26.27c-.17.16-.33.33-.48.5s-.17.19-.25.28-.31.37-.47.56l-.21.27c-.16.21-.31.43-.46.64l-.17.25c-.17.24-.32.49-.48.75a1.63,1.63,0,0,1-.11.17c-.18.32-.36.64-.52,1h0c-.1.2-.19.4-.28.6a2.39,2.39,0,0,0-.13.28c-.08.18-.16.36-.23.54l-.15.35-.18.51-.13.4-.15.47-.12.46c0,.14-.07.29-.1.43s-.07.33-.1.5,0,.26-.07.39,0,.38-.07.57l0,.31q0,.43,0,.87l.38,170.49c0,2.28.78,3.92,2,4.76h0a3.58,3.58,0,0,0,.42.25l7.87,4.58.12.07.06,0c1.38.72,3.24.59,5.29-.6l211.92-122a16.8,16.8,0,0,0,7.61-13.18Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M417.7,181.93V178.2a5.06,5.06,0,0,0-2.32-4l-67.15-38.78a1.62,1.62,0,0,0-1.69-.13h0l-2.27,1.64s1.48.92,1.48,1l.15,0v5.27l69.6,40.18Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.7,181.93V178.2a5.06,5.06,0,0,0-2.32-4l-67.15-38.78a1.62,1.62,0,0,0-1.69-.13h0l-2.27,1.64s1.48.92,1.48,1l.15,0v5.27l69.6,40.18Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.49,183.3l-69.6-40.18-.13,47.74a5.08,5.08,0,0,0,2.31,4L414.19,233l-.6.76,1.11,1.58,2.26-1.63h0a1.64,1.64,0,0,0,.61-1.42l.14-50.39Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.18,175.79a5.13,5.13,0,0,1,2.32,4v3.5l-71.81-41.46v-3.5c0-1.47,1.05-2.06,2.33-1.32Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M413.18,175.79a5.13,5.13,0,0,1,2.32,4v3.5l-71.81-41.46v-3.5c0-1.47,1.05-2.06,2.33-1.32Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M415.49,183.3l-.15,50.62c0,1.47-1,2.06-2.33,1.32l-67.16-38.77a5.08,5.08,0,0,1-2.31-4l.14-50.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.26 197.33 367.25 199.44 347.32 187.94 347.32 185.82 367.26 197.33",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "411.86 191.67 411.86 193.79 360.56 164.17 360.57 162.06 411.86 191.67",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.36 161.42 367.35 163.53 347.42 152.02 347.43 149.91 367.36 161.42",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "367.26 197.33 367.25 199.44 347.32 187.94 347.32 185.82 367.26 197.33",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "411.86 191.67 411.86 193.79 360.56 164.17 360.57 162.06 411.86 191.67",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.36 161.42 367.35 163.53 347.42 152.02 347.43 149.91 367.36 161.42",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.3 184.25 367.29 186.36 347.36 174.85 347.36 172.74 367.3 184.25",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "361.32 171.67 361.32 173.78 347.38 165.74 347.39 163.62 361.32 171.67",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "386.11 212.79 386.11 214.89 360.46 200.09 360.47 197.98 386.11 212.79",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.53 207.33 392.52 209.45 360.49 190.95 360.49 188.84 392.53 207.33",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.43 175.18 376.42 177.29 360.55 168.13 360.56 166.01 376.43 175.18",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "399.63 198.35 399.62 200.46 360.52 177.89 360.53 175.77 399.63 198.35",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "411.8 214.51 411.79 216.62 360.5 187 360.5 184.89 411.8 214.51",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M75.8,350.7V347a5.12,5.12,0,0,1,2.32-4l67.16-38.78a1.59,1.59,0,0,1,1.69-.12h0l2.27,1.64s-1.48.92-1.48,1-.06,0-.15,0v5.27L78,352.07Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8,350.7V347a5.12,5.12,0,0,1,2.32-4l67.16-38.78a1.59,1.59,0,0,1,1.69-.12h0l2.27,1.64s-1.48.92-1.48,1-.06,0-.15,0v5.27L78,352.07Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78,352.07l69.59-40.18.14,47.74a5.12,5.12,0,0,1-2.31,4L79.31,401.81l.61.76-1.11,1.58-2.26-1.63h0a1.67,1.67,0,0,1-.62-1.43L75.8,350.7Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.33,344.56a5.1,5.1,0,0,0-2.32,4v3.5l71.8-41.46v-3.5c0-1.47-1-2.06-2.32-1.32Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.33,344.56a5.1,5.1,0,0,0-2.32,4v3.5l71.8-41.46v-3.5c0-1.47-1-2.06-2.32-1.32Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M78,352.07l.14,50.62c0,1.47,1,2.06,2.34,1.32l67.15-38.77a5.09,5.09,0,0,0,2.32-4l-.15-50.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "81.75 392.18 81.75 394.3 101.69 382.79 101.68 380.67 81.75 392.18",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "81.71 379.1 81.72 381.21 101.65 369.7 101.64 367.59 81.71 379.1",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "81.71 370.11 81.72 372.22 95.65 364.17 95.64 362.06 81.71 370.11",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.69 388.3 95.7 390.41 121.34 375.6 121.34 373.5 95.69 388.3",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.75 379.24 95.76 381.35 127.8 362.86 127.79 360.74 95.75 379.24",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.58 357.06 94.59 359.17 110.46 350.01 110.45 347.89 94.58 357.06",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.78 365.62 95.79 367.73 134.89 345.15 134.88 343.04 95.78 365.62",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.75 375.44 95.76 377.56 147.06 347.94 147.05 345.83 95.75 375.44",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.52 353.27 94.53 355.39 145.82 325.77 145.81 323.66 94.52 353.27",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "81.64 356.27 81.65 358.38 101.58 346.87 101.58 344.76 81.64 356.27",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "81.75 392.18 81.75 394.3 101.69 382.79 101.68 380.67 81.75 392.18",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "81.71 379.1 81.72 381.21 101.65 369.7 101.64 367.59 81.71 379.1",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "81.71 370.11 81.72 372.22 95.65 364.17 95.64 362.06 81.71 370.11",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.69 388.3 95.7 390.41 121.34 375.6 121.34 373.5 95.69 388.3",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.75 379.24 95.76 381.35 127.8 362.86 127.79 360.74 95.75 379.24",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.58 357.06 94.59 359.17 110.46 350.01 110.45 347.89 94.58 357.06",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.78 365.62 95.79 367.73 134.89 345.15 134.88 343.04 95.78 365.62",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.75 375.44 95.76 377.56 147.06 347.94 147.05 345.83 95.75 375.44",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.52 353.27 94.53 355.39 145.82 325.77 145.81 323.66 94.52 353.27",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "81.64 356.27 81.65 358.38 101.58 346.87 101.58 344.76 81.64 356.27",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M262,323.28l-.08-29.63a4.3,4.3,0,0,1,2-3.41L304.8,266.6a1.4,1.4,0,0,1,1.36-.15l-2.55-1.53h0a1.4,1.4,0,0,0-1.37.15l-40.93,23.64a4.32,4.32,0,0,0-2,3.41l.08,29.63A1.36,1.36,0,0,0,260,323l2.55,1.53h0A1.4,1.4,0,0,1,262,323.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.78,267.73a1.39,1.39,0,0,0-.48-1.18l-.06-.06-.08,0a1.4,1.4,0,0,0-1.36.15l-40.94,23.64a4.3,4.3,0,0,0-2,3.41l.08,29.63a1.4,1.4,0,0,0,.56,1.26,1.37,1.37,0,0,0,1.43-.12l40.94-23.64a4.36,4.36,0,0,0,2-3.42Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262,323.28l-.08-29.63a4.3,4.3,0,0,1,2-3.41L304.8,266.6a1.4,1.4,0,0,1,1.36-.15l-2.55-1.53h0a1.4,1.4,0,0,0-1.37.15l-40.93,23.64a4.32,4.32,0,0,0-2,3.41l.08,29.63A1.36,1.36,0,0,0,260,323l2.55,1.53h0A1.4,1.4,0,0,1,262,323.28Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "279.78 293.57 279.78 295.81 271.46 304.32 279.8 303.2 279.81 305.44 269.27 306.74 269.27 304.42 279.78 293.57",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "290.45 280.06 282.78 309.94 280.74 311.13 288.41 281.24 290.45 280.06",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "291.18 286.99 301.71 285.69 301.72 288.01 291.22 298.86 291.21 296.62 299.56 288.09 291.19 289.23 291.18 286.99",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "296.5 191.05 306.81 199.16 306.83 207.09 272.55 226.88 272.53 218.95 279.06 205.98 284.93 210.53 282.85 216.98 285.86 211.25 296.5 191.05",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.24,195c1.61-.93,2.93-.18,2.93,1.67a6.41,6.41,0,0,1-2.91,5c-1.61.93-2.93.18-2.93-1.67A6.41,6.41,0,0,1,285.24,195Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "153.56 225.67 164.6 234.36 164.63 242.85 127.9 264.05 127.88 255.56 134.88 241.66 141.16 246.54 138.94 253.44 142.16 247.31 153.56 225.67",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.5,230c1.73-1,3.13-.2,3.14,1.79a6.89,6.89,0,0,1-3.12,5.4c-1.73,1-3.13.2-3.14-1.79A6.84,6.84,0,0,1,141.5,230Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.3 184.25 367.29 186.36 347.36 174.85 347.36 172.74 367.3 184.25",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "361.32 171.67 361.32 173.78 347.38 165.74 347.39 163.62 361.32 171.67",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "386.11 212.79 386.11 214.89 360.46 200.09 360.47 197.98 386.11 212.79",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.53 207.33 392.52 209.45 360.49 190.95 360.49 188.84 392.53 207.33",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.43 175.18 376.42 177.29 360.55 168.13 360.56 166.01 376.43 175.18",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "399.63 198.35 399.62 200.46 360.52 177.89 360.53 175.77 399.63 198.35",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "411.8 214.51 411.79 216.62 360.5 187 360.5 184.89 411.8 214.51",
    style: {
      fill: "#4169E1"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M359.39,50.57c-3.08-1.78-5.68-.91-6.5,1.85a9.24,9.24,0,0,0-3.33-3.7c-2.41-1.39-4.37-.27-4.38,2.5v1.27l-3.24-1.87c-1.69-1-3.06-.19-3.07,1.76a6.71,6.71,0,0,0,3.05,5.27l27.42,15.83c1.69,1,3.07.2,3.07-1.74a6.7,6.7,0,0,0-3.05-5.28l-3.24-1.87V62.25A14.85,14.85,0,0,0,359.39,50.57Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.78,92.7c-8.11-4.68-15-2.39-17.14,4.89a24,24,0,0,0-8.76-9.75c-6.36-3.67-11.53-.72-11.55,6.58v3.35l-8.53-4.92c-4.45-2.58-8.07-.51-8.08,4.61s3.58,11.34,8,13.91L424,153.1c4.45,2.57,8.08.51,8.09-4.61s-3.59-11.35-8-13.92l-8.53-4.92,0-6.17C415.58,112.16,407.63,98.39,397.78,92.7Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "384.13 107.31 392.85 123.26 387.58 120.22 387.54 132 380.58 127.98 380.61 116.2 375.34 113.16 384.13 107.31",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "387.58 133.65 387.57 138.16 380.6 134.14 380.62 129.63 387.58 133.65",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "387.58 139.97 387.57 142.22 380.6 138.2 380.62 135.95 387.58 139.97",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "387.58 143.74 387.57 145.1 380.6 141.07 380.62 139.71 387.58 143.74",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "384.13 107.31 392.85 123.26 387.58 120.22 387.54 132 380.58 127.98 380.61 116.2 375.34 113.16 384.13 107.31",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "387.58 133.65 387.57 138.16 380.6 134.14 380.62 129.63 387.58 133.65",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "387.58 139.97 387.57 142.22 380.6 138.2 380.62 135.95 387.58 139.97",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "387.58 143.74 387.57 145.1 380.6 141.07 380.62 139.71 387.58 143.74",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M167.29,30.42c8.11-4.68,15-2.39,17.14,4.89a24.13,24.13,0,0,1,8.76-9.76c6.35-3.66,11.53-.72,11.55,6.58v3.36l8.53-4.93c4.45-2.57,8.07-.5,8.08,4.62s-3.58,11.34-8,13.91L141.06,90.81c-4.45,2.57-8.08.52-8.09-4.6s3.58-11.35,8-13.92l8.53-4.93,0-6.17C149.49,49.88,157.44,36.1,167.29,30.42Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.07 91 188.79 75.05 183.53 78.09 183.49 66.3 176.53 70.33 176.56 82.11 171.29 85.15 180.07 91",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "183.53 64.66 183.52 60.15 176.55 64.17 176.56 68.68 183.53 64.66",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "183.53 58.34 183.52 56.08 176.55 60.11 176.56 62.36 183.53 58.34",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "183.53 54.57 183.52 53.21 176.55 57.23 176.56 58.6 183.53 54.57",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "180.07 91 188.79 75.05 183.53 78.09 183.49 66.3 176.53 70.33 176.56 82.11 171.29 85.15 180.07 91",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "183.53 64.66 183.52 60.15 176.55 64.17 176.56 68.68 183.53 64.66",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "183.53 58.34 183.52 56.08 176.55 60.11 176.56 62.36 183.53 58.34",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "183.53 54.57 183.52 53.21 176.55 57.23 176.56 58.6 183.53 54.57",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gears--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.48,137.76l-.26.24Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9,136.14a6.66,6.66,0,0,0,.7-.36l.72-.45.23-.17c.16-.12.32-.23.47-.36l.26-.21c.15-.12.29-.25.43-.38L62,134l.31-.31c.18-.18.34-.36.51-.54l.29-.33.29-.36c.12-.14.23-.29.35-.44l.21-.28c.13-.18.25-.36.37-.55l.15-.22.48-.77s0-.09.07-.14c.13-.22.25-.45.37-.68l.12-.23c.12-.24.23-.48.34-.73a.93.93,0,0,0,0-.1c.12-.27.23-.55.33-.83l.09-.25c.07-.2.14-.4.2-.61a2.81,2.81,0,0,0,.1-.31c.05-.18.1-.36.14-.54s.07-.26.1-.39,0-.27.08-.41.08-.4.1-.6,0-.37.07-.55l0-.27c0-.28,0-.56,0-.83a8.81,8.81,0,0,0-.07-1,9.54,9.54,0,0,0-1,.5,16.64,16.64,0,0,0-7.55,13.08,9,9,0,0,0,.06,1.06l.16-.06Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.16,122.18l.2.2Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.75,140.11Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.06,138.94l-.23.17Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7,121.8l.22.16Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.43,124.53c0,.1,0,.19.07.29C73.48,124.72,73.45,124.63,73.43,124.53Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.58,125.35c0,.09,0,.18,0,.27C73.61,125.53,73.59,125.44,73.58,125.35Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.92,123.2a2,2,0,0,1,.14.25A2,2,0,0,0,72.92,123.2Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.21,123.82c0,.1.07.18.11.28C73.28,124,73.24,123.92,73.21,123.82Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.57,122.65c.05.07.12.14.17.22C72.69,122.79,72.62,122.72,72.57,122.65Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.41,110.6l.44,0-.44,0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.77,117.86l.18-.2h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3,136.9c-.16.19-.33.36-.5.54C69,137.26,69.14,137.09,69.3,136.9Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7,110.6h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.81,131l-.09.25Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.26,133.2h0l.15-.56h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6,117l.27-.28h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.81,135.11c0-.26.11-.52.17-.78h0C50.92,134.59,50.86,134.85,50.81,135.11Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.47,140.6h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.82,135h0l.14-.22h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.44,134h0l.08-.13h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.23,140.33l.14,0h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.88,133.14l.12-.23-.12.23Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.26,129.54h0l.09-.39h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6,127.59a10.6,10.6,0,0,0,.06-1.11q0,.42,0,.84Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.34,132.18h0l0-.1h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.43,128.73h0c0-.2.08-.4.11-.6h0C73.51,128.33,73.47,128.53,73.43,128.73Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73,130.39l.09-.31-.09.31Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.23,135.78h0l.21-.29h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.69,140.5l.31-.06h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.07,140.59l.23,0h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.79,140.5l.12,0h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.33,140.34l.54-.18h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.54,138.59l-.26.19c.26-.2.51-.4.75-.61l-.24.2Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.24,140a8.88,8.88,0,0,0,.87-.44l-.69.36Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.59,136.57h0q.15-.16.3-.36h0Q69.74,136.41,69.59,136.57Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.15,151.1l-.61.76,5.85,3.4-1.23-4.57A10.93,10.93,0,0,1,58.15,151.1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.34,117.48l4.58-1.26-5.86-3.4-.4,1A11,11,0,0,1,81.34,117.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.58,125.35a4.51,4.51,0,0,0-.08-.53c0-.1,0-.19-.07-.29s-.07-.29-.11-.43-.08-.18-.11-.28-.09-.25-.15-.37a2,2,0,0,0-.14-.25,3.47,3.47,0,0,0-.18-.33c0-.08-.12-.15-.17-.22a3.17,3.17,0,0,0-.21-.27l-.2-.2c-.08-.07-.15-.15-.24-.22l-.22-.16a4.69,4.69,0,0,0-4.62-.15,8.81,8.81,0,0,1,.07,1c0,.27,0,.55,0,.83l0,.27c0,.18,0,.36-.07.55s-.06.4-.1.6,0,.28-.08.41-.06.26-.1.39-.09.36-.14.54a2.81,2.81,0,0,1-.1.31c-.06.21-.13.41-.2.61l-.09.25c-.1.28-.21.56-.33.83a.93.93,0,0,1,0,.1c-.11.25-.22.49-.34.73l-.12.23c-.12.23-.24.46-.37.68,0,.05,0,.09-.07.14l-.48.77-.15.22c-.12.19-.24.37-.37.55l-.21.28c-.12.15-.23.3-.35.44l-.29.36-.29.33c-.17.18-.33.36-.51.54L62,134l-.26.24c-.14.13-.28.26-.43.38l-.26.21c-.15.13-.31.24-.47.36l-.23.17-.72.45a6.66,6.66,0,0,1-.7.36l-.17.09-.16.06a4.82,4.82,0,0,0,2.18,3.82h0a3,3,0,0,0,.48.22l.12,0h0a2.58,2.58,0,0,0,.42.12l.11,0h0a5,5,0,0,0,.56.07h.6l.21,0h0a2.63,2.63,0,0,0,.39-.06l.3-.06h0l.33-.1.54-.18h0l.37-.15.18-.08.69-.36c.24-.14.48-.3.72-.46l.23-.17.22-.16.26-.19.25-.22.24-.2.19-.17.26-.24c.11-.1.21-.21.32-.32s.34-.35.5-.54.2-.21.29-.33h0q.15-.16.3-.36h0c.11-.14.23-.28.34-.43h0l.21-.29h0l.38-.54h0l.14-.22h0c.17-.26.33-.51.48-.78h0l.08-.13h0c.12-.23.25-.45.36-.68h0l.12-.23c.12-.24.23-.49.34-.73h0l0-.1h0c.12-.28.23-.56.33-.83l.09-.25c.08-.2.14-.41.21-.61h0l.09-.31.15-.54h0l.09-.39h0c0-.14.06-.28.08-.42h0c0-.2.08-.4.11-.6h0l.06-.54,0-.27q0-.42,0-.84a8,8,0,0,0,0-.86C73.61,125.53,73.59,125.44,73.58,125.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "47.72 145.09 46.25 145.49 45.6 145.12 43.63 150.18 50.14 153.97 52.51 147.88 47.72 145.09",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "69.14 107.8 74.02 110.63 78.11 105.51 71.6 101.73 68.12 106.07 68.78 106.46 69.14 107.8",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.83,144.24l-3.11.85,4.79,2.79A10.92,10.92,0,0,1,50.83,144.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,111a12,12,0,0,1,2.69-.42h.71l.44,0H74l-4.88-2.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51,134.33h0c.09-.37.18-.75.28-1.13h0l.15-.56h0q.45-1.56,1.05-3.09L46,125.76c0,.1-.08.19-.11.29s-.11.31-.17.47l-.3.83-.06.18c-.05.13-.08.26-.13.4-.09.31-.19.61-.28.92a2.58,2.58,0,0,1-.08.26c0,.1,0,.2-.07.3-.1.38-.2.76-.28,1.14,0,.11-.06.22-.08.33a3.82,3.82,0,0,0-.09.44l6.51,3.79C50.86,134.85,50.92,134.59,51,134.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.06,119.84c.55-.69,1.12-1.34,1.71-2l.18-.2h0l.65-.66.27-.28h0c.39-.38.79-.75,1.19-1.11l-6.51-3.78c-.4.35-.8.73-1.19,1.11l-.11.1-.54.55-.28.29c-.3.33-.61.66-.9,1l0,0c-.33.37-.65.76-1,1.15h0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "50.81 135.11 44.3 131.32 39.72 135.36 46.23 139.14 50.81 135.11",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "46.23 139.14 39.72 135.36 39.74 141.71 45.6 145.12 46.25 145.49 46.23 139.14",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.26 109.65 56.75 105.86 55.55 111.83 62.06 115.61 63.26 109.65",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "68.78 106.46 68.12 106.07 62.27 102.67 56.75 105.86 63.26 109.65 68.78 106.46",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "50.06 126.21 43.55 122.42 45.95 125.76 52.46 129.55 50.06 126.21",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "58.06 119.84 51.55 116.05 51.55 116.05 47.44 115.68 53.95 119.46 58.06 119.84",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "53.95 119.46 47.44 115.68 43.55 122.42 50.06 126.21 53.95 119.46",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.36,126.61l4.58-4,0-6.35-4.58,1.26a11,11,0,0,0-1.68-3.64l.4-1,2-5.07-3.92-2.24L74,110.63h-.17l-.44,0H72.7A12,12,0,0,0,70,111l-.87-3.22-.36-1.34-5.52,3.19-1.2,6c-.4.36-.8.73-1.19,1.11l-.27.28-.65.66-.18.2c-.59.64-1.16,1.29-1.71,2L54,119.46l-3.89,6.75,2.4,3.34q-.6,1.53-1.05,3.09l-.15.56c-.1.38-.19.76-.28,1.13s-.12.52-.17.78l-4.58,4,0,6.35,1.47-.4,3.11-.85a10.92,10.92,0,0,0,1.68,3.64L50.14,154l3.92,2.23,3.48-4.34.61-.76a10.93,10.93,0,0,0,4-.41l1.23,4.57,5.52-3.19,1.2-6a32.09,32.09,0,0,0,4-4.22l4.12.37,3.89-6.74-2.4-3.33A32.65,32.65,0,0,0,81.36,126.61Zm-7.76,1-.06.54c0,.2-.07.4-.11.6s-.05.28-.08.42l-.09.39-.15.54-.09.31c-.07.2-.13.41-.21.61l-.09.25c-.1.27-.21.55-.33.83l0,.1c-.11.24-.22.49-.34.73l-.12.23c-.11.23-.24.45-.36.68l-.08.13c-.15.27-.31.52-.48.78l-.14.22-.38.54-.21.29c-.11.15-.23.29-.34.43s-.2.25-.3.36-.19.22-.29.33-.33.36-.5.54-.21.22-.32.32l-.26.24-.19.17c-.24.21-.49.41-.75.61l-.22.16-.23.17c-.24.16-.48.32-.72.46a8.88,8.88,0,0,1-.87.44l-.37.15-.54.18-.33.1-.31.06a2.63,2.63,0,0,1-.39.06l-.23,0h-.6a5,5,0,0,1-.56-.07l-.12,0a2.58,2.58,0,0,1-.42-.12l-.14,0a3,3,0,0,1-.48-.22h0a4.82,4.82,0,0,1-2.18-3.82,9,9,0,0,1-.06-1.06,16.64,16.64,0,0,1,7.55-13.08,9.54,9.54,0,0,1,1-.5,4.69,4.69,0,0,1,4.62.15l.22.16c.09.07.16.15.24.22l.2.2a3.17,3.17,0,0,1,.21.27c.05.07.12.14.17.22a3.47,3.47,0,0,1,.18.33,2,2,0,0,1,.14.25c.06.12.1.25.15.37s.07.18.11.28.07.29.11.43,0,.19.07.29a4.51,4.51,0,0,1,.08.53c0,.09,0,.18,0,.27a8,8,0,0,1,0,.86A10.6,10.6,0,0,1,73.6,127.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.15,151.1l-.61.76,5.85,3.4-1.23-4.57A10.93,10.93,0,0,1,58.15,151.1Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.34,117.48l4.58-1.26-5.86-3.4-.4,1A11,11,0,0,1,81.34,117.48Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.58,125.35a4.51,4.51,0,0,0-.08-.53c0-.1,0-.19-.07-.29s-.07-.29-.11-.43-.08-.18-.11-.28-.09-.25-.15-.37a2,2,0,0,0-.14-.25,3.47,3.47,0,0,0-.18-.33c0-.08-.12-.15-.17-.22a3.17,3.17,0,0,0-.21-.27l-.2-.2c-.08-.07-.15-.15-.24-.22l-.22-.16a4.69,4.69,0,0,0-4.62-.15,8.81,8.81,0,0,1,.07,1c0,.27,0,.55,0,.83l0,.27c0,.18,0,.36-.07.55s-.06.4-.1.6,0,.28-.08.41-.06.26-.1.39-.09.36-.14.54a2.81,2.81,0,0,1-.1.31c-.06.21-.13.41-.2.61l-.09.25c-.1.28-.21.56-.33.83a.93.93,0,0,1,0,.1c-.11.25-.22.49-.34.73l-.12.23c-.12.23-.24.46-.37.68,0,.05,0,.09-.07.14l-.48.77-.15.22c-.12.19-.24.37-.37.55l-.21.28c-.12.15-.23.3-.35.44l-.29.36-.29.33c-.17.18-.33.36-.51.54L62,134l-.26.24c-.14.13-.28.26-.43.38l-.26.21c-.15.13-.31.24-.47.36l-.23.17-.72.45a6.66,6.66,0,0,1-.7.36l-.17.09-.16.06a4.82,4.82,0,0,0,2.18,3.82h0a3,3,0,0,0,.48.22l.12,0h0a2.58,2.58,0,0,0,.42.12l.11,0h0a5,5,0,0,0,.56.07h.6l.21,0h0a2.63,2.63,0,0,0,.39-.06l.3-.06h0l.33-.1.54-.18h0l.37-.15.18-.08.69-.36c.24-.14.48-.3.72-.46l.23-.17.22-.16.26-.19.25-.22.24-.2.19-.17.26-.24c.11-.1.21-.21.32-.32s.34-.35.5-.54.2-.21.29-.33h0q.15-.16.3-.36h0c.11-.14.23-.28.34-.43h0l.21-.29h0l.38-.54h0l.14-.22h0c.17-.26.33-.51.48-.78h0l.08-.13h0c.12-.23.25-.45.36-.68h0l.12-.23c.12-.24.23-.49.34-.73h0l0-.1h0c.12-.28.23-.56.33-.83l.09-.25c.08-.2.14-.41.21-.61h0l.09-.31.15-.54h0l.09-.39h0c0-.14.06-.28.08-.42h0c0-.2.08-.4.11-.6h0l.06-.54,0-.27q0-.42,0-.84a8,8,0,0,0,0-.86C73.61,125.53,73.59,125.44,73.58,125.35Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "47.72 145.09 46.25 145.49 45.6 145.12 43.63 150.18 50.14 153.97 52.51 147.88 47.72 145.09",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.83,144.24l-3.11.85,4.79,2.79A10.92,10.92,0,0,1,50.83,144.24Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,111a12,12,0,0,1,2.69-.42h.71l.44,0H74l-4.88-2.83Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51,134.33h0c.09-.37.18-.75.28-1.13h0l.15-.56h0q.45-1.56,1.05-3.09L46,125.76c0,.1-.08.19-.11.29s-.11.31-.17.47l-.3.83-.06.18c-.05.13-.08.26-.13.4-.09.31-.19.61-.28.92a2.58,2.58,0,0,1-.08.26c0,.1,0,.2-.07.3-.1.38-.2.76-.28,1.14,0,.11-.06.22-.08.33a3.82,3.82,0,0,0-.09.44l6.51,3.79C50.86,134.85,50.92,134.59,51,134.33Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "46.23 139.14 39.72 135.36 39.74 141.71 45.6 145.12 46.25 145.49 46.23 139.14",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.26 109.65 56.75 105.86 55.55 111.83 62.06 115.61 63.26 109.65",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "50.06 126.21 43.55 122.42 45.95 125.76 52.46 129.55 50.06 126.21",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "58.06 119.84 51.55 116.05 51.55 116.05 47.44 115.68 53.95 119.46 58.06 119.84",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "69.14 107.8 74.02 110.63 78.11 105.51 71.6 101.73 68.12 106.07 68.78 106.46 69.14 107.8",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.06,119.84c.55-.69,1.12-1.34,1.71-2l.18-.2h0l.65-.66.27-.28h0c.39-.38.79-.75,1.19-1.11l-6.51-3.78c-.4.35-.8.73-1.19,1.11l-.11.1-.54.55-.28.29c-.3.33-.61.66-.9,1l0,0c-.33.37-.65.76-1,1.15h0Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "50.81 135.11 44.3 131.32 39.72 135.36 46.23 139.14 50.81 135.11",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "68.78 106.46 68.12 106.07 62.27 102.67 56.75 105.86 63.26 109.65 68.78 106.46",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "53.95 119.46 47.44 115.68 43.55 122.42 50.06 126.21 53.95 119.46",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.29,119.63l-.18.17Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.52,118.49l.49-.25q.26-.15.51-.33l.16-.12.34-.25.18-.15c.1-.09.2-.17.3-.27l.18-.16.23-.23c.12-.12.24-.25.35-.38l.21-.23.21-.26.24-.31.15-.2.27-.38c0-.06.07-.11.1-.16s.23-.36.34-.55l0-.09c.09-.16.18-.32.26-.48a1.3,1.3,0,0,0,.08-.17c.09-.17.17-.34.25-.52l0-.06.24-.59.06-.18c0-.14.1-.28.14-.43a1.87,1.87,0,0,0,.07-.22c0-.13.07-.25.1-.38a2.29,2.29,0,0,0,.07-.28l.06-.29c0-.14,0-.28.07-.43s0-.25,0-.38a1.23,1.23,0,0,1,0-.19c0-.2,0-.4,0-.59a5.74,5.74,0,0,0,0-.74,5.94,5.94,0,0,0-.72.35,11.8,11.8,0,0,0-5.35,9.26,5.87,5.87,0,0,0,0,.74l.11,0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.89,108.61l.15.14Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.82,121.29Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.29,120.47l-.17.12Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.57,108.34l.16.11Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.79,110.28a1.46,1.46,0,0,1,0,.2A1.46,1.46,0,0,0,114.79,110.28Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.9,110.86l0,.18Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.43,109.33l.1.18Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.63,109.78a1.08,1.08,0,0,1,.08.19A1.08,1.08,0,0,0,114.63,109.78Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.18,108.94a1.67,1.67,0,0,1,.12.16A1.67,1.67,0,0,0,114.18,108.94Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.78,100.42h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.13,105.56l.12-.14h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.87,119l-.35.38Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.28,100.42h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.36,114.85a1.34,1.34,0,0,0-.07.18A1.34,1.34,0,0,1,114.36,114.85Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.11,116.41h0c0-.13.07-.27.11-.4h0C99.18,116.14,99.14,116.27,99.11,116.41Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.72,104.94l.19-.19h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.79,117.76c0-.19.08-.37.12-.55h0C98.87,117.39,98.82,117.57,98.79,117.76Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107,121.64h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.94,117.64h0l.11-.15h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.38,116.94h0l.06-.1h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.16,121.45l.1,0h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.7,116.36s0-.1.08-.16-.06.11-.08.16Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.67,113.82h0c0-.1,0-.19.07-.28h0C114.72,113.63,114.69,113.72,114.67,113.82Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.91,112.44a7.11,7.11,0,0,0,0-.78c0,.19,0,.39,0,.59A1.37,1.37,0,0,1,114.91,112.44Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114,115.68h0l0-.07h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.79,113.25h0c0-.14.06-.29.08-.43h0C114.85,113,114.82,113.11,114.79,113.25Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.5,114.42l.07-.22-.07.22Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.53,118.23h0l.15-.2h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.9,121.57l.22,0h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.46,121.63h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.55,121.57l.09,0h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.36,121.46l.38-.13h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.62,120.22l-.18.13c.18-.13.36-.28.53-.43l-.17.15Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109,121.22a5.84,5.84,0,0,0,.61-.31,4.59,4.59,0,0,1-.49.26Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.08,118.79h0a2.43,2.43,0,0,0,.2-.25h0A2.43,2.43,0,0,1,112.08,118.79Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104,129.07l-.43.54,4.14,2.4-.87-3.23A7.93,7.93,0,0,1,104,129.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.39,105.29l3.24-.89L119.48,102l-.28.72A7.68,7.68,0,0,1,120.39,105.29Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.9,110.86c0-.13,0-.26-.06-.38a1.46,1.46,0,0,0,0-.2c0-.11-.05-.21-.08-.31a1.08,1.08,0,0,0-.08-.19,2.15,2.15,0,0,0-.1-.27l-.1-.18a1.71,1.71,0,0,0-.13-.23,1.67,1.67,0,0,0-.12-.16l-.14-.19-.15-.14s-.1-.11-.16-.16l-.16-.11a3.31,3.31,0,0,0-3.27-.1,5.74,5.74,0,0,1,0,.74c0,.19,0,.39,0,.59a1.23,1.23,0,0,0,0,.19c0,.13,0,.26,0,.38s-.05.29-.07.43l-.06.29a2.29,2.29,0,0,1-.07.28c0,.13-.06.25-.1.38a1.87,1.87,0,0,1-.07.22c0,.15-.09.29-.14.43l-.06.18-.24.59,0,.06c-.08.18-.16.35-.25.52a1.3,1.3,0,0,1-.08.17c-.08.16-.17.32-.26.48l0,.09c-.11.19-.22.37-.34.55s-.07.1-.1.16l-.27.38-.15.2-.24.31-.21.26-.21.23c-.11.13-.23.26-.35.38l-.23.23-.18.16c-.1.1-.2.18-.3.27l-.18.15-.34.25-.16.12q-.26.18-.51.33l-.49.25-.13.06-.11,0a3.4,3.4,0,0,0,1.54,2.7h0a1.5,1.5,0,0,0,.34.16l.08,0h0l.29.08.08,0h0a2.57,2.57,0,0,0,.4,0h.58l.28-.05.22,0h0l.24-.07.37-.13h0l.26-.11.12,0a4.59,4.59,0,0,0,.49-.26c.18-.1.35-.21.51-.32l.17-.12.15-.12.18-.13.18-.15.17-.15.14-.12.18-.17.23-.22.35-.38.21-.24h0a2.43,2.43,0,0,0,.2-.25h0a3.76,3.76,0,0,0,.25-.31h0l.15-.2h0l.26-.39h0l.11-.15h0c.11-.18.23-.36.33-.55h0l.06-.1h0c.09-.15.17-.31.26-.48h0s0-.1.08-.16.17-.34.24-.52h0l0-.07h0c.09-.19.17-.39.24-.58a1.34,1.34,0,0,1,.07-.18c0-.14.09-.29.14-.43h0l.07-.22c0-.13.07-.26.1-.38h0c0-.1,0-.19.07-.28h0a2.93,2.93,0,0,0,.05-.29h0c0-.14.06-.29.08-.43h0c0-.13,0-.26,0-.38a1.37,1.37,0,0,0,0-.19c0-.2,0-.4,0-.59a6.13,6.13,0,0,0,0-.62Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "96.6 124.82 95.56 125.1 95.11 124.84 93.71 128.42 98.31 131.1 100 126.79 96.6 124.82",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.76 98.44 115.21 100.44 118.11 96.82 113.5 94.14 111.04 97.22 111.5 97.49 111.76 98.44",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.81,124.22l-2.21.6,3.39,2A7.52,7.52,0,0,1,98.81,124.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.37,100.72a8.31,8.31,0,0,1,1.91-.3h.1a2.67,2.67,0,0,1,.4,0h.43l-3.45-2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.91,117.21h0c.06-.27.13-.53.2-.8h0c0-.14.07-.27.11-.4h0c.21-.73.45-1.46.74-2.19l-4.61-2.68-.08.21-.12.33-.21.59s0,.08,0,.12-.06.19-.09.29-.14.43-.2.65l-.06.18c0,.08,0,.15,0,.22-.07.27-.14.53-.2.8a2.1,2.1,0,0,1-.06.24l-.06.31,4.61,2.68C98.82,117.57,98.87,117.39,98.91,117.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.92,107c.39-.49.79-.95,1.21-1.4l.12-.14h0l.47-.48.19-.19h0c.27-.27.55-.53.84-.79l-4.61-2.67q-.42.38-.84.78a.27.27,0,0,1-.08.07l-.38.4-.2.2-.64.71h0l-.68.82h0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.79 117.76 94.18 115.08 90.94 117.93 95.55 120.61 98.79 117.76",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.55 120.61 90.94 117.93 90.95 122.42 95.11 124.84 95.56 125.1 95.55 120.61",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.6 99.75 102.99 97.07 102.14 101.29 106.75 103.96 107.6 99.75",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.5 97.49 111.04 97.22 106.9 94.81 102.99 97.07 107.6 99.75 111.5 97.49",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.26 111.46 93.65 108.78 95.35 111.14 99.96 113.82 98.26 111.46",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.92 106.95 99.31 104.28 99.31 104.28 96.41 104.01 101.01 106.69 103.92 106.95",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104,129.07l-.43.54,4.14,2.4-.87-3.23A7.93,7.93,0,0,1,104,129.07Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.39,105.29l3.24-.89L119.48,102l-.28.72A7.68,7.68,0,0,1,120.39,105.29Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.9,110.86c0-.13,0-.26-.06-.38a1.46,1.46,0,0,0,0-.2c0-.11-.05-.21-.08-.31a1.08,1.08,0,0,0-.08-.19,2.15,2.15,0,0,0-.1-.27l-.1-.18a1.71,1.71,0,0,0-.13-.23,1.67,1.67,0,0,0-.12-.16l-.14-.19-.15-.14s-.1-.11-.16-.16l-.16-.11a3.31,3.31,0,0,0-3.27-.1,5.74,5.74,0,0,1,0,.74c0,.19,0,.39,0,.59a1.23,1.23,0,0,0,0,.19c0,.13,0,.26,0,.38s-.05.29-.07.43l-.06.29a2.29,2.29,0,0,1-.07.28c0,.13-.06.25-.1.38a1.87,1.87,0,0,1-.07.22c0,.15-.09.29-.14.43l-.06.18-.24.59,0,.06c-.08.18-.16.35-.25.52a1.3,1.3,0,0,1-.08.17c-.08.16-.17.32-.26.48l0,.09c-.11.19-.22.37-.34.55s-.07.1-.1.16l-.27.38-.15.2-.24.31-.21.26-.21.23c-.11.13-.23.26-.35.38l-.23.23-.18.16c-.1.1-.2.18-.3.27l-.18.15-.34.25-.16.12q-.26.18-.51.33l-.49.25-.13.06-.11,0a3.4,3.4,0,0,0,1.54,2.7h0a1.5,1.5,0,0,0,.34.16l.08,0h0l.29.08.08,0h0a2.57,2.57,0,0,0,.4,0h.58l.28-.05.22,0h0l.24-.07.37-.13h0l.26-.11.12,0a4.59,4.59,0,0,0,.49-.26c.18-.1.35-.21.51-.32l.17-.12.15-.12.18-.13.18-.15.17-.15.14-.12.18-.17.23-.22.35-.38.21-.24h0a2.43,2.43,0,0,0,.2-.25h0a3.76,3.76,0,0,0,.25-.31h0l.15-.2h0l.26-.39h0l.11-.15h0c.11-.18.23-.36.33-.55h0l.06-.1h0c.09-.15.17-.31.26-.48h0s0-.1.08-.16.17-.34.24-.52h0l0-.07h0c.09-.19.17-.39.24-.58a1.34,1.34,0,0,1,.07-.18c0-.14.09-.29.14-.43h0l.07-.22c0-.13.07-.26.1-.38h0c0-.1,0-.19.07-.28h0a2.93,2.93,0,0,0,.05-.29h0c0-.14.06-.29.08-.43h0c0-.13,0-.26,0-.38a1.37,1.37,0,0,0,0-.19c0-.2,0-.4,0-.59a6.13,6.13,0,0,0,0-.62Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "96.6 124.82 95.56 125.1 95.11 124.84 93.71 128.42 98.31 131.1 100 126.79 96.6 124.82",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.81,124.22l-2.21.6,3.39,2A7.52,7.52,0,0,1,98.81,124.22Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.37,100.72a8.31,8.31,0,0,1,1.91-.3h.1a2.67,2.67,0,0,1,.4,0h.43l-3.45-2Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.91,117.21h0c.06-.27.13-.53.2-.8h0c0-.14.07-.27.11-.4h0c.21-.73.45-1.46.74-2.19l-4.61-2.68-.08.21-.12.33-.21.59s0,.08,0,.12-.06.19-.09.29-.14.43-.2.65l-.06.18c0,.08,0,.15,0,.22-.07.27-.14.53-.2.8a2.1,2.1,0,0,1-.06.24l-.06.31,4.61,2.68C98.82,117.57,98.87,117.39,98.91,117.21Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.55 120.61 90.94 117.93 90.95 122.42 95.11 124.84 95.56 125.1 95.55 120.61",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.6 99.75 102.99 97.07 102.14 101.29 106.75 103.96 107.6 99.75",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.26 111.46 93.65 108.78 95.35 111.14 99.96 113.82 98.26 111.46",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.92 106.95 99.31 104.28 99.31 104.28 96.41 104.01 101.01 106.69 103.92 106.95",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.01 106.69 96.41 104.01 93.65 108.78 98.26 111.46 101.01 106.69",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.76 98.44 115.21 100.44 118.11 96.82 113.5 94.14 111.04 97.22 111.5 97.49 111.76 98.44",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.92,107c.39-.49.79-.95,1.21-1.4l.12-.14h0l.47-.48.19-.19h0c.27-.27.55-.53.84-.79l-4.61-2.67q-.42.38-.84.78a.27.27,0,0,1-.08.07l-.38.4-.2.2-.64.71h0l-.68.82h0Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.79 117.76 94.18 115.08 90.94 117.93 95.55 120.61 98.79 117.76",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.5 97.49 111.04 97.22 106.9 94.81 102.99 97.07 107.6 99.75 111.5 97.49",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.01 106.69 96.41 104.01 93.65 108.78 98.26 111.46 101.01 106.69",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.4,111.75l3.24-2.86V104.4l-3.24.89a7.68,7.68,0,0,0-1.19-2.58l.28-.72,1.4-3.59-2.77-1.58-2.9,3.62h-.43a2.67,2.67,0,0,0-.4,0h-.1a8.31,8.31,0,0,0-1.91.3l-.61-2.28-.25-1-3.91,2.26-.85,4.21c-.29.26-.57.52-.84.79l-.19.19-.47.48-.12.14c-.42.45-.82.91-1.21,1.4l-2.91-.27-2.75,4.77,1.7,2.36c-.29.73-.53,1.46-.74,2.19,0,.13-.08.27-.11.4s-.14.53-.2.8-.09.36-.12.55l-3.24,2.85v4.49l1-.28,2.21-.6a7.52,7.52,0,0,0,1.18,2.57l-1.68,4.31,2.78,1.58,2.46-3.07.43-.54a7.93,7.93,0,0,0,2.84-.29l.87,3.23,3.91-2.25.84-4.22a22.38,22.38,0,0,0,2.83-3l2.91.26,2.75-4.77-1.69-2.36A23.11,23.11,0,0,0,120.4,111.75Zm-5.49.69c0,.12,0,.25,0,.38s-.05.29-.08.43a2.93,2.93,0,0,1-.05.29c0,.09,0,.18-.07.28s-.07.25-.1.38l-.07.22c0,.14-.09.29-.14.43a1.34,1.34,0,0,0-.07.18c-.07.19-.15.39-.24.58l0,.07c-.07.18-.16.35-.24.52s-.06.11-.08.16-.17.33-.26.48l-.06.1c-.1.19-.22.37-.33.55l-.11.15-.26.39-.15.2a3.76,3.76,0,0,1-.25.31,2.43,2.43,0,0,1-.2.25l-.21.24-.35.38-.23.22-.18.17-.14.12c-.17.15-.35.3-.53.43l-.15.12-.17.12c-.16.11-.33.22-.51.32a5.84,5.84,0,0,1-.61.31l-.26.11-.38.13-.24.07-.22,0-.28.05H107a2.57,2.57,0,0,1-.4,0l-.09,0-.29-.08-.1,0a1.5,1.5,0,0,1-.34-.16h0a3.4,3.4,0,0,1-1.54-2.7,5.87,5.87,0,0,1,0-.74,11.8,11.8,0,0,1,5.35-9.26,5.94,5.94,0,0,1,.72-.35,3.31,3.31,0,0,1,3.27.1l.16.11c.06,0,.11.11.16.16l.15.14.14.19a1.67,1.67,0,0,1,.12.16,1.71,1.71,0,0,1,.13.23l.1.18a2.15,2.15,0,0,1,.1.27,1.08,1.08,0,0,1,.08.19c0,.1.05.2.08.31a1.46,1.46,0,0,1,0,.2c0,.12,0,.25.06.38l0,.18a6.13,6.13,0,0,1,0,.62A7.11,7.11,0,0,1,114.91,112.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.85,230.82l.16.15Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.9,229.8a4.64,4.64,0,0,1-.44-.23,4.34,4.34,0,0,1-.46-.28l-.14-.11-.3-.23-.17-.13-.27-.24-.16-.15-.2-.2-.32-.34-.18-.21-.19-.22-.21-.28-.14-.18-.23-.34-.1-.14-.3-.49a.41.41,0,0,0,0-.09l-.23-.43s-.05-.09-.07-.14-.15-.31-.22-.47l0-.06-.21-.52a1,1,0,0,1,0-.16c-.05-.13-.09-.26-.13-.38l-.06-.2c0-.11-.07-.23-.1-.34l-.06-.25c0-.08,0-.17-.05-.26l-.06-.38c0-.11,0-.23,0-.34a1.11,1.11,0,0,1,0-.17c0-.18,0-.36,0-.53s0-.45,0-.66c.21.09.43.19.65.31a10.53,10.53,0,0,1,4.77,8.27c0,.23,0,.45,0,.66l-.1,0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.53,221l-.13.13Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.73,232.31h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.75,231.57l.14.11Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.82,220.74l-.15.1Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.72,222.47c0,.06,0,.12,0,.18S431.71,222.53,431.72,222.47Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.63,223l0,.16Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432,221.62c0,.06-.06.11-.08.16S432,221.68,432,221.62Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.86,222c0,.06-.05.11-.07.17S431.84,222.08,431.86,222Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.27,221.28a.76.76,0,0,0-.11.14A.76.76,0,0,1,432.27,221.28Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.74,213.67h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.35,218.26l-.11-.13h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.33,230.28c.1.12.21.23.32.34C434.54,230.51,434.43,230.4,434.33,230.28Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.18,213.67h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.11,226.55l.06.16Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.73,227.94h0c0-.12-.07-.23-.1-.35h0C445.66,227.71,445.69,227.82,445.73,227.94Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.83,217.71l-.18-.17h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446,229.15c0-.17-.07-.33-.11-.49h0C445.94,228.82,446,229,446,229.15Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.64,232.61h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.37,229.05h0l-.09-.14h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433,228.42h0l-.05-.09h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.43,232.45l-.09,0h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.7,227.9a.61.61,0,0,1-.07-.14.91.91,0,0,0,.07.14Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.83,225.63h0l-.06-.25h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.61,224.4a5.54,5.54,0,0,1,0-.7,3.17,3.17,0,0,0,0,.53C431.6,224.28,431.61,224.34,431.61,224.4Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.41,227.3h0l0-.07h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.72,225.12h0c0-.13-.05-.25-.07-.38h0C431.67,224.87,431.7,225,431.72,225.12Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432,226.17l-.06-.2.06.2Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.74,229.57h0l-.13-.18h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.87,232.55l-.19,0h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.27,232.61l-.15,0h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.08,232.55l-.08,0h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.47,232.45l-.34-.11h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.44,231.34l.16.12-.47-.38.15.13Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.89,232.24a5.72,5.72,0,0,1-.55-.28c.15.09.3.16.44.23Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.15,230.07h0c-.07-.07-.13-.15-.19-.22h0C434,229.92,434.08,230,434.15,230.07Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.37,239.25l.39.48-3.7,2.14.78-2.88A7.09,7.09,0,0,0,441.37,239.25Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.73,218l-2.9-.79,3.7-2.15.26.65A6.92,6.92,0,0,0,426.73,218Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.63,223a1.86,1.86,0,0,1,.05-.34c0-.06,0-.12,0-.18a2.86,2.86,0,0,0,.07-.28c0-.06,0-.11.07-.17a2.44,2.44,0,0,1,.1-.24c0-.05.06-.1.08-.16l.12-.2a.76.76,0,0,1,.11-.14,1.09,1.09,0,0,1,.13-.17l.13-.13.14-.14.15-.1a2.93,2.93,0,0,1,2.91-.09c0,.21,0,.43,0,.66s0,.35,0,.53a1.11,1.11,0,0,0,0,.17c0,.11,0,.23,0,.34l.06.38c0,.09,0,.18.05.26l.06.25c0,.11.06.23.1.34l.06.2c0,.12.08.25.13.38a1,1,0,0,0,0,.16l.21.52,0,.06c.07.16.14.31.22.47s.05.09.07.14l.23.43a.41.41,0,0,1,0,.09l.3.49.1.14.23.34.14.18.21.28.19.22.18.21.32.34.2.2.16.15.27.24.17.13.3.23.14.11a4.34,4.34,0,0,0,.46.28,4.64,4.64,0,0,0,.44.23l.11,0,.1,0a3,3,0,0,1-1.38,2.41h0l-.3.14-.08,0h0l-.26.07-.07,0h0a2.09,2.09,0,0,1-.36,0h-.37l-.14,0h0l-.25,0-.19,0h0a1.66,1.66,0,0,1-.21-.06l-.34-.11h0l-.24-.1-.11-.05c-.14-.07-.29-.14-.44-.23s-.3-.18-.45-.28l-.14-.11-.15-.11-.16-.12-.16-.13-.15-.13L435,231l-.16-.15a1.89,1.89,0,0,1-.2-.2c-.11-.11-.22-.22-.32-.34l-.18-.21h0c-.07-.07-.13-.15-.19-.22h0l-.22-.28h0l-.13-.18h0l-.24-.34h0l-.09-.14h0l-.3-.49h0l-.05-.09h0c-.08-.14-.16-.28-.23-.43h0a.91.91,0,0,1-.07-.14c-.08-.15-.15-.31-.22-.46h0l0-.07h0c-.08-.17-.15-.35-.21-.52l-.06-.16c0-.13-.09-.25-.13-.38h0l-.06-.2-.09-.34h0l-.06-.25h0c0-.08,0-.17,0-.26h0c0-.13-.05-.25-.07-.38h0c0-.11,0-.23,0-.34s0-.12,0-.17a3.17,3.17,0,0,1,0-.53,5,5,0,0,1,0-.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "447.96 235.45 448.89 235.71 449.3 235.47 450.55 238.67 446.43 241.06 444.93 237.21 447.96 235.45",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "434.43 211.9 431.35 213.69 428.76 210.45 432.88 208.06 435.07 210.81 434.66 211.05 434.43 211.9",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446,234.92l2,.53-3,1.76A6.54,6.54,0,0,0,446,234.92Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.88,213.94a7.06,7.06,0,0,0-1.7-.27h-.83l3.08-1.79Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.9,228.66h0c0-.24-.11-.48-.17-.72h0c0-.12-.07-.23-.1-.35h0c-.19-.66-.41-1.31-.66-2l4.11-2.39.07.18.11.3.18.52.05.12.07.25c.06.2.13.39.18.59a.75.75,0,0,1,.05.16c0,.06,0,.13,0,.19.06.24.12.48.17.72l.06.21a2.33,2.33,0,0,1,.05.28L446,229.15C446,229,445.94,228.82,445.9,228.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.43,219.5c-.35-.43-.71-.85-1.08-1.24l-.11-.13h0l-.41-.42-.18-.17h0c-.24-.25-.49-.48-.75-.71l4.11-2.39.76.7.07.07.33.35.18.18q.3.31.57.63h0c.21.24.41.48.61.73h0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "446.01 229.15 450.12 226.76 453.01 229.31 448.9 231.69 446.01 229.15",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "448.9 231.69 453.01 229.31 453 233.31 449.3 235.47 448.89 235.71 448.9 231.69",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "438.15 213.07 442.26 210.68 443.01 214.44 438.9 216.83 438.15 213.07",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "434.66 211.05 435.07 210.81 438.77 208.66 442.26 210.68 438.15 213.07 434.66 211.05",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "446.48 223.53 450.6 221.14 449.08 223.24 444.97 225.63 446.48 223.53",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "441.43 219.5 445.54 217.11 445.54 217.11 448.14 216.87 444.02 219.26 441.43 219.5",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "444.02 219.26 448.14 216.87 450.6 221.14 446.48 223.53 444.02 219.26",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.75,227.29l-1.51,2.11,2.46,4.26,2.6-.23a19.34,19.34,0,0,0,2.52,2.66l.75,3.77,3.49,2,.78-2.88a7.09,7.09,0,0,0,2.53.26l.39.48,2.2,2.74,2.47-1.41-1.5-3.85a6.54,6.54,0,0,0,1.06-2.29l2,.53.93.26v-4L446,229.15c0-.17-.07-.33-.11-.49s-.11-.48-.17-.72-.07-.23-.1-.35c-.19-.66-.41-1.31-.66-2l1.51-2.1L444,219.26l-2.59.24c-.35-.43-.71-.85-1.08-1.24l-.11-.13-.41-.42-.18-.17c-.24-.25-.49-.48-.75-.71l-.75-3.76-3.49-2-.23.85-.55,2a7.06,7.06,0,0,0-1.7-.27h-.83l-2.59-3.24-2.47,1.42,1.24,3.2.26.65a6.92,6.92,0,0,0-1.06,2.29l-2.9-.79v4l2.89,2.55A20.93,20.93,0,0,0,427.75,227.29Zm3.83-3.59a5,5,0,0,1,0-.55l0-.16a1.86,1.86,0,0,1,.05-.34c0-.06,0-.12,0-.18a2.86,2.86,0,0,0,.07-.28c0-.06,0-.11.07-.17a2.44,2.44,0,0,1,.1-.24c0-.05.06-.1.08-.16l.12-.2a.76.76,0,0,1,.11-.14,1.09,1.09,0,0,1,.13-.17l.13-.13.14-.14.15-.1a2.93,2.93,0,0,1,2.91-.09c.21.09.43.19.65.31a10.53,10.53,0,0,1,4.77,8.27c0,.23,0,.45,0,.66a3,3,0,0,1-1.38,2.41h0l-.3.14-.09,0-.26.07-.08,0a2.09,2.09,0,0,1-.36,0h-.37l-.15,0-.25,0-.19,0a1.66,1.66,0,0,1-.21-.06l-.34-.11-.24-.1a5.72,5.72,0,0,1-.55-.28c-.15-.08-.3-.18-.45-.28l-.14-.11-.15-.11-.47-.38L435,231l-.16-.15a1.89,1.89,0,0,1-.2-.2c-.11-.11-.22-.22-.32-.34l-.18-.21c-.07-.07-.13-.15-.19-.22l-.22-.28-.13-.18-.24-.34-.09-.14-.3-.49-.05-.09c-.08-.14-.16-.28-.23-.43a.61.61,0,0,1-.07-.14c-.08-.15-.15-.31-.22-.46l0-.07c-.08-.17-.15-.35-.21-.52l-.06-.16c0-.13-.09-.25-.13-.38l-.06-.2-.09-.34-.06-.25c0-.08,0-.17,0-.26s-.05-.25-.07-.38,0-.23,0-.34A5.54,5.54,0,0,1,431.58,223.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.37,239.25l.39.48-3.7,2.14.78-2.88A7.09,7.09,0,0,0,441.37,239.25Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.73,218l-2.9-.79,3.7-2.15.26.65A6.92,6.92,0,0,0,426.73,218Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.63,223a1.86,1.86,0,0,1,.05-.34c0-.06,0-.12,0-.18a2.86,2.86,0,0,0,.07-.28c0-.06,0-.11.07-.17a2.44,2.44,0,0,1,.1-.24c0-.05.06-.1.08-.16l.12-.2a.76.76,0,0,1,.11-.14,1.09,1.09,0,0,1,.13-.17l.13-.13.14-.14.15-.1a2.93,2.93,0,0,1,2.91-.09c0,.21,0,.43,0,.66s0,.35,0,.53a1.11,1.11,0,0,0,0,.17c0,.11,0,.23,0,.34l.06.38c0,.09,0,.18.05.26l.06.25c0,.11.06.23.1.34l.06.2c0,.12.08.25.13.38a1,1,0,0,0,0,.16l.21.52,0,.06c.07.16.14.31.22.47s.05.09.07.14l.23.43a.41.41,0,0,1,0,.09l.3.49.1.14.23.34.14.18.21.28.19.22.18.21.32.34.2.2.16.15.27.24.17.13.3.23.14.11a4.34,4.34,0,0,0,.46.28,4.64,4.64,0,0,0,.44.23l.11,0,.1,0a3,3,0,0,1-1.38,2.41h0l-.3.14-.08,0h0l-.26.07-.07,0h0a2.09,2.09,0,0,1-.36,0h-.37l-.14,0h0l-.25,0-.19,0h0a1.66,1.66,0,0,1-.21-.06l-.34-.11h0l-.24-.1-.11-.05c-.14-.07-.29-.14-.44-.23s-.3-.18-.45-.28l-.14-.11-.15-.11-.16-.12-.16-.13-.15-.13L435,231l-.16-.15a1.89,1.89,0,0,1-.2-.2c-.11-.11-.22-.22-.32-.34l-.18-.21h0c-.07-.07-.13-.15-.19-.22h0l-.22-.28h0l-.13-.18h0l-.24-.34h0l-.09-.14h0l-.3-.49h0l-.05-.09h0c-.08-.14-.16-.28-.23-.43h0a.91.91,0,0,1-.07-.14c-.08-.15-.15-.31-.22-.46h0l0-.07h0c-.08-.17-.15-.35-.21-.52l-.06-.16c0-.13-.09-.25-.13-.38h0l-.06-.2-.09-.34h0l-.06-.25h0c0-.08,0-.17,0-.26h0c0-.13-.05-.25-.07-.38h0c0-.11,0-.23,0-.34s0-.12,0-.17a3.17,3.17,0,0,1,0-.53,5,5,0,0,1,0-.55Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "447.96 235.45 448.89 235.71 449.3 235.47 450.55 238.67 446.43 241.06 444.93 237.21 447.96 235.45",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446,234.92l2,.53-3,1.76A6.54,6.54,0,0,0,446,234.92Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.88,213.94a7.06,7.06,0,0,0-1.7-.27h-.83l3.08-1.79Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.9,228.66h0c0-.24-.11-.48-.17-.72h0c0-.12-.07-.23-.1-.35h0c-.19-.66-.41-1.31-.66-2l4.11-2.39.07.18.11.3.18.52.05.12.07.25c.06.2.13.39.18.59a.75.75,0,0,1,.05.16c0,.06,0,.13,0,.19.06.24.12.48.17.72l.06.21a2.33,2.33,0,0,1,.05.28L446,229.15C446,229,445.94,228.82,445.9,228.66Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "448.9 231.69 453.01 229.31 453 233.31 449.3 235.47 448.89 235.71 448.9 231.69",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "438.15 213.07 442.26 210.68 443.01 214.44 438.9 216.83 438.15 213.07",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "446.48 223.53 450.6 221.14 449.08 223.24 444.97 225.63 446.48 223.53",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "441.43 219.5 445.54 217.11 445.54 217.11 448.14 216.87 444.02 219.26 441.43 219.5",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "434.43 211.9 431.35 213.69 428.76 210.45 432.88 208.06 435.07 210.81 434.66 211.05 434.43 211.9",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.43,219.5c-.35-.43-.71-.85-1.08-1.24l-.11-.13h0l-.41-.42-.18-.17h0c-.24-.25-.49-.48-.75-.71l4.11-2.39.76.7.07.07.33.35.18.18q.3.31.57.63h0c.21.24.41.48.61.73h0Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "446.01 229.15 450.12 226.76 453.01 229.31 448.9 231.69 446.01 229.15",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "434.66 211.05 435.07 210.81 438.77 208.66 442.26 210.68 438.15 213.07 434.66 211.05",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "444.02 219.26 448.14 216.87 450.6 221.14 446.48 223.53 444.02 219.26",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.51,260.56l.11.11Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.69,259.86l-.31-.16-.31-.2-.1-.07-.21-.16-.11-.09-.19-.17-.11-.1-.14-.14-.22-.24-.13-.14-.13-.16a1.33,1.33,0,0,1-.14-.19l-.1-.12-.16-.24-.07-.1c-.07-.11-.14-.22-.2-.33l0-.06-.16-.3-.05-.1-.15-.32,0,0-.15-.37,0-.11a1.14,1.14,0,0,1-.09-.26.74.74,0,0,1,0-.14c0-.08-.05-.16-.07-.23s0-.12,0-.17l0-.19a2,2,0,0,1-.05-.26l0-.24s0-.07,0-.11,0-.25,0-.37l0-.46.45.22a7.27,7.27,0,0,1,3.3,5.72,3.44,3.44,0,0,1,0,.46l-.06,0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.9,253.76l-.09.08Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.88,261.59Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.12,261.08l.1.07Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.1,253.59l-.1.07Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.34,254.78l0,.13Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.27,255.14s0,.08,0,.12S452.27,255.18,452.27,255.14Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.56,254.2l-.06.11Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.44,254.47a.61.61,0,0,0-.05.12A.61.61,0,0,1,452.44,254.47Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.72,254l-.08.1Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.35,248.69h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.31,251.87l-.08-.09h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.14,260.19l.22.23Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.66,248.7h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.61,257.61s0,.07,0,.11S452.62,257.64,452.61,257.61Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462,258.57h0c0-.08,0-.16-.07-.25h0C462,258.41,462,258.49,462,258.57Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458,251.49l-.12-.12h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.23,259.4c0-.11-.05-.22-.08-.33h0C462.18,259.18,462.2,259.29,462.23,259.4Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.13,261.8h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.48,259.33h0l-.06-.09h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.21,258.9h0l0-.06h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.67,261.69l-.06,0h.06Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453,258.54a.31.31,0,0,1,0-.1.31.31,0,0,0,0,.1Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.42,257h0l-.05-.17h0A1,1,0,0,0,452.42,257Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.27,256.12a4.12,4.12,0,0,1,0-.48c0,.12,0,.24,0,.36S452.26,256.08,452.27,256.12Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.82,258.12h0l0,0h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.34,256.62h0c0-.09,0-.18,0-.26h0C452.31,256.44,452.32,256.53,452.34,256.62Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.52,257.34l0-.13,0,.13Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.74,259.7h0l-.09-.13h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.6,261.76l-.14,0h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.87,261.8h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.43,261.76h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.32,261.69l-.24-.08h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.92,260.92l.11.09-.33-.27.1.09Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.92,261.54a2.25,2.25,0,0,1-.38-.19l.3.16Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454,260h0l-.13-.15h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459,266.39l.26.33-2.55,1.49.53-2A4.76,4.76,0,0,0,459,266.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.89,251.7l-2-.55,2.56-1.49.18.45A4.66,4.66,0,0,0,448.89,251.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.27,255.14a1.57,1.57,0,0,1,0-.23l0-.13c0-.06,0-.13.05-.19a.61.61,0,0,1,.05-.12l.06-.16.06-.11s.05-.1.08-.14l.08-.1.09-.12.09-.08a.47.47,0,0,1,.1-.1l.1-.07a2,2,0,0,1,2-.07l0,.46c0,.12,0,.24,0,.37s0,.07,0,.11l0,.24a2,2,0,0,0,.05.26l0,.19s0,.11,0,.17,0,.15.07.23a.74.74,0,0,0,0,.14,1.14,1.14,0,0,0,.09.26l0,.11.15.37,0,0,.15.32.05.1.16.3,0,.06c.06.11.13.22.2.33l.07.1.16.24.1.12a1.33,1.33,0,0,0,.14.19l.13.16.13.14.22.24.14.14.11.1.19.17.11.09.21.16.1.07.31.2.31.16.08,0,.06,0a2.09,2.09,0,0,1-.95,1.67h0l-.21.1h-.06l-.18.05h-.06a1,1,0,0,1-.24,0h-.36l-.17,0-.14,0h0l-.14,0-.24-.08h0l-.16-.07-.08,0-.3-.16-.32-.2-.1-.07L455,261l-.11-.09-.12-.09-.1-.09-.08-.07-.11-.11-.15-.14-.22-.23L454,260h0l-.13-.15h0l-.15-.19h0l-.09-.13h0l-.17-.24h0l-.06-.09h0l-.21-.34h0l0-.06h0c-.06-.1-.11-.2-.16-.3h0a.31.31,0,0,1,0-.1,1.87,1.87,0,0,1-.15-.32h0l0,0h0c-.06-.12-.1-.24-.15-.36s0-.08,0-.11l-.09-.27h0l0-.13-.06-.24h0a1,1,0,0,1,0-.17h0l0-.18h0c0-.09,0-.18,0-.26h0a1.94,1.94,0,0,1,0-.24s0-.08,0-.12,0-.24,0-.36,0-.26,0-.38S452.27,255.18,452.27,255.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "463.58 263.76 464.22 263.94 464.5 263.78 465.36 265.99 462.52 267.64 461.48 264.98 463.58 263.76",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "454.21 247.47 452.08 248.71 450.29 246.47 453.14 244.82 454.66 246.72 454.37 246.88 454.21 247.47",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.21,263.39l1.37.38-2.1,1.21A4.57,4.57,0,0,0,462.21,263.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.84,248.88a5.13,5.13,0,0,0-1.18-.18h-.58l2.13-1.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.15,259.07h0l-.12-.5h0c0-.08,0-.16-.07-.25h0c-.13-.45-.28-.9-.46-1.35l2.85-1.65a.61.61,0,0,0,0,.12l.07.21c0,.12.09.24.13.36l0,.08c0,.06,0,.12.05.18s.09.27.13.4l0,.11,0,.14c.05.16.09.33.13.49l0,.15a1.29,1.29,0,0,1,0,.19l-2.84,1.65C462.2,259.29,462.18,259.18,462.15,259.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.06,252.73c-.24-.3-.49-.59-.75-.86l-.08-.09h0l-.28-.29-.12-.12h0l-.52-.49,2.84-1.65.52.49.05,0,.24.24.12.13c.13.14.27.29.39.44h0l.42.51h0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "462.23 259.4 465.07 257.75 467.07 259.51 464.23 261.17 462.23 259.4",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "464.23 261.17 467.07 259.51 467.06 262.29 464.5 263.78 464.22 263.94 464.23 261.17",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "456.79 248.28 459.63 246.63 460.15 249.23 457.31 250.88 456.79 248.28",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "454.37 246.88 454.66 246.72 457.22 245.23 459.63 246.63 456.79 248.28 454.37 246.88",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "462.55 255.51 465.4 253.86 464.35 255.32 461.5 256.97 462.55 255.51",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "459.06 252.73 461.9 251.08 461.9 251.08 463.7 250.91 460.85 252.57 459.06 252.73",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "460.85 252.57 463.7 250.91 465.4 253.86 462.55 255.51 460.85 252.57",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.6,258.12l-1.05,1.46,1.7,2.95,1.8-.17a13.34,13.34,0,0,0,1.74,1.85l.52,2.6,2.42,1.4.53-2a4.76,4.76,0,0,0,1.76.18l.26.33,1.53,1.9,1.71-1-1-2.66a4.57,4.57,0,0,0,.73-1.59l1.37.38.64.17v-2.77l-2-1.77c0-.11-.05-.22-.08-.33l-.12-.5c0-.08,0-.16-.07-.25-.13-.45-.28-.9-.46-1.35l1.05-1.46-1.7-2.94-1.79.16c-.24-.3-.49-.59-.75-.86l-.08-.09-.28-.29-.12-.12-.52-.49-.52-2.6-2.42-1.4-.16.59-.37,1.41a5.13,5.13,0,0,0-1.18-.18h-.58l-1.79-2.24-1.71,1,.86,2.21.18.45a4.66,4.66,0,0,0-.73,1.59l-2-.55v2.78l2,1.76A14.67,14.67,0,0,0,449.6,258.12Zm2.64-2.48c0-.14,0-.26,0-.38s0-.08,0-.12a1.57,1.57,0,0,1,0-.23l0-.13c0-.06,0-.13.05-.19a.61.61,0,0,1,.05-.12l.06-.16.06-.11s.05-.1.08-.14l.08-.1.09-.12.09-.08a.47.47,0,0,1,.1-.1l.1-.07a2,2,0,0,1,2-.07l.45.22a7.27,7.27,0,0,1,3.3,5.72,3.44,3.44,0,0,1,0,.46,2.09,2.09,0,0,1-.95,1.67h0l-.21.1-.06,0-.18.05h-.06a1,1,0,0,1-.24,0h-.36l-.17,0-.14,0-.14,0-.24-.08-.16-.07a2.25,2.25,0,0,1-.38-.19l-.32-.2-.1-.07L455,261l-.33-.27-.08-.07-.11-.11-.15-.14-.22-.23L454,260l-.13-.15-.15-.19-.09-.13-.17-.24-.06-.09-.21-.34,0-.06c-.06-.1-.11-.2-.16-.3a.31.31,0,0,1,0-.1,1.87,1.87,0,0,1-.15-.32l0,0c-.06-.12-.1-.24-.15-.36s0-.08,0-.11l-.09-.27,0-.13-.06-.24-.05-.17,0-.18c0-.09,0-.18,0-.26a1.94,1.94,0,0,1,0-.24A4.12,4.12,0,0,1,452.24,255.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459,266.39l.26.33-2.55,1.49.53-2A4.76,4.76,0,0,0,459,266.39Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.89,251.7l-2-.55,2.56-1.49.18.45A4.66,4.66,0,0,0,448.89,251.7Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.27,255.14a1.57,1.57,0,0,1,0-.23l0-.13c0-.06,0-.13.05-.19a.61.61,0,0,1,.05-.12l.06-.16.06-.11s.05-.1.08-.14l.08-.1.09-.12.09-.08a.47.47,0,0,1,.1-.1l.1-.07a2,2,0,0,1,2-.07l0,.46c0,.12,0,.24,0,.37s0,.07,0,.11l0,.24a2,2,0,0,0,.05.26l0,.19s0,.11,0,.17,0,.15.07.23a.74.74,0,0,0,0,.14,1.14,1.14,0,0,0,.09.26l0,.11.15.37,0,0,.15.32.05.1.16.3,0,.06c.06.11.13.22.2.33l.07.1.16.24.1.12a1.33,1.33,0,0,0,.14.19l.13.16.13.14.22.24.14.14.11.1.19.17.11.09.21.16.1.07.31.2.31.16.08,0,.06,0a2.09,2.09,0,0,1-.95,1.67h0l-.21.1h-.06l-.18.05h-.06a1,1,0,0,1-.24,0h-.36l-.17,0-.14,0h0l-.14,0-.24-.08h0l-.16-.07-.08,0-.3-.16-.32-.2-.1-.07L455,261l-.11-.09-.12-.09-.1-.09-.08-.07-.11-.11-.15-.14-.22-.23L454,260h0l-.13-.15h0l-.15-.19h0l-.09-.13h0l-.17-.24h0l-.06-.09h0l-.21-.34h0l0-.06h0c-.06-.1-.11-.2-.16-.3h0a.31.31,0,0,1,0-.1,1.87,1.87,0,0,1-.15-.32h0l0,0h0c-.06-.12-.1-.24-.15-.36s0-.08,0-.11l-.09-.27h0l0-.13-.06-.24h0a1,1,0,0,1,0-.17h0l0-.18h0c0-.09,0-.18,0-.26h0a1.94,1.94,0,0,1,0-.24s0-.08,0-.12,0-.24,0-.36,0-.26,0-.38S452.27,255.18,452.27,255.14Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "463.58 263.76 464.22 263.94 464.5 263.78 465.36 265.99 462.52 267.64 461.48 264.98 463.58 263.76",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.21,263.39l1.37.38-2.1,1.21A4.57,4.57,0,0,0,462.21,263.39Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.84,248.88a5.13,5.13,0,0,0-1.18-.18h-.58l2.13-1.24Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.15,259.07h0l-.12-.5h0c0-.08,0-.16-.07-.25h0c-.13-.45-.28-.9-.46-1.35l2.85-1.65a.61.61,0,0,0,0,.12l.07.21c0,.12.09.24.13.36l0,.08c0,.06,0,.12.05.18s.09.27.13.4l0,.11,0,.14c.05.16.09.33.13.49l0,.15a1.29,1.29,0,0,1,0,.19l-2.84,1.65C462.2,259.29,462.18,259.18,462.15,259.07Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "464.23 261.17 467.07 259.51 467.06 262.29 464.5 263.78 464.22 263.94 464.23 261.17",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "456.79 248.28 459.63 246.63 460.15 249.23 457.31 250.88 456.79 248.28",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "462.55 255.51 465.4 253.86 464.35 255.32 461.5 256.97 462.55 255.51",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "459.06 252.73 461.9 251.08 461.9 251.08 463.7 250.91 460.85 252.57 459.06 252.73",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "454.21 247.47 452.08 248.71 450.29 246.47 453.14 244.82 454.66 246.72 454.37 246.88 454.21 247.47",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.06,252.73c-.24-.3-.49-.59-.75-.86l-.08-.09h0l-.28-.29-.12-.12h0l-.52-.49,2.84-1.65.52.49.05,0,.24.24.12.13c.13.14.27.29.39.44h0l.42.51h0Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "462.23 259.4 465.07 257.75 467.07 259.51 464.23 261.17 462.23 259.4",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "454.37 246.88 454.66 246.72 457.22 245.23 459.63 246.63 456.79 248.28 454.37 246.88",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "460.85 252.57 463.7 250.91 465.4 253.86 462.55 255.51 460.85 252.57",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.56,258l.09.08Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435,257.36l-.25-.13-.26-.17-.08-.06a1.09,1.09,0,0,1-.17-.13.39.39,0,0,1-.1-.08l-.15-.13-.1-.09a1.14,1.14,0,0,1-.11-.11l-.19-.2-.1-.12-.11-.13-.12-.16-.08-.1-.13-.2-.06-.08a2.61,2.61,0,0,1-.17-.28l0-.05-.13-.24,0-.09-.13-.26,0,0-.12-.3,0-.09c0-.08-.05-.15-.07-.22a.56.56,0,0,1,0-.12c0-.06,0-.13-.05-.19l0-.14a.8.8,0,0,1,0-.15,2.07,2.07,0,0,1,0-.22l0-.2a.38.38,0,0,0,0-.1c0-.1,0-.2,0-.3a2.34,2.34,0,0,1,0-.38l.37.18a6.09,6.09,0,0,1,2.74,4.75,2.34,2.34,0,0,1,0,.38l0,0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.22,252.29l-.07.07Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.37,258.8Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.08,258.38l.08.06Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.39,252.15l-.08.06Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.76,253.15a.3.3,0,0,0,0,.1A.3.3,0,0,1,429.76,253.15Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.71,253.44s0,.07,0,.1S429.7,253.48,429.71,253.44Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430,252.66a.41.41,0,0,0-.05.09A.41.41,0,0,1,430,252.66Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.84,252.89l0,.1Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.08,252.46l-.07.08Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.77,248.09h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.72,250.72l-.06-.07h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.26,257.64l.18.19Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430,248.09h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430,255.49l0,.09Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.81,256.29h0l-.06-.2h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.42,250.41l-.1-.1h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438,257c0-.09,0-.18-.06-.28h0C437.93,256.8,438,256.89,438,257Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.74,259h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.71,256.93h0a.56.56,0,0,0,0-.08h0A.56.56,0,0,1,430.71,256.93Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.49,256.56h0l0-.05h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.19,258.88l-.05,0h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.32,256.27a.2.2,0,0,0,0-.08.2.2,0,0,1,0,.08Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.83,255h0a.74.74,0,0,1,0-.14h0A.74.74,0,0,0,429.83,255Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.7,254.25c0-.13,0-.27,0-.4,0,.1,0,.21,0,.31S429.7,254.22,429.7,254.25Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.16,255.92h0l0,0h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.76,254.67h0c0-.07,0-.15,0-.22h0C429.73,254.52,429.75,254.6,429.76,254.67Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.91,255.27l0-.11,0,.11Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.92,257.23h0l-.07-.11h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.3,258.94l-.12,0h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.52,259h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434,258.94h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.06,258.88l-.19-.06h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.9,258.25l.09.07-.27-.23.09.08Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.73,258.76a3.07,3.07,0,0,1-.31-.16l.25.13Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.16,257.52h0l-.11-.13h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.31,262.79l.22.27-2.12,1.24.44-1.66A4.2,4.2,0,0,0,435.31,262.79Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.89,250.59l-1.66-.46,2.13-1.24.14.38A4,4,0,0,0,426.89,250.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.71,253.44a1.25,1.25,0,0,1,0-.19.3.3,0,0,1,0-.1,1.24,1.24,0,0,0,0-.16l0-.1.06-.14a.41.41,0,0,1,.05-.09l.06-.12.07-.08a.61.61,0,0,1,.07-.1l.07-.07.09-.08.08-.06a1.73,1.73,0,0,1,1.68-.05,2.34,2.34,0,0,0,0,.38c0,.1,0,.2,0,.3a.38.38,0,0,1,0,.1l0,.2a2.07,2.07,0,0,0,0,.22.8.8,0,0,0,0,.15l0,.14c0,.06,0,.13.05.19a.56.56,0,0,0,0,.12c0,.07,0,.14.07.22l0,.09.12.3,0,0,.13.26,0,.09.13.24,0,.05a2.61,2.61,0,0,0,.17.28l.06.08.13.2.08.1.12.16.11.13.1.12.19.2a1.14,1.14,0,0,0,.11.11l.1.09.15.13a.39.39,0,0,0,.1.08,1.09,1.09,0,0,0,.17.13l.08.06.26.17.25.13.07,0,0,0a1.75,1.75,0,0,1-.78,1.39h0l-.18.08,0,0h0l-.15,0h-.05l-.2,0h-.3l-.14,0-.11,0h0l-.12,0-.19-.06h0l-.14-.06-.06,0-.25-.13a2.26,2.26,0,0,1-.26-.16l-.08-.06-.09-.06-.09-.07-.09-.08-.09-.08-.07-.06-.09-.08-.12-.12-.18-.19-.1-.12h0l-.11-.13h0a1,1,0,0,0-.13-.16h0l-.07-.11h0l-.14-.19h0a.56.56,0,0,0,0-.08h0c-.06-.1-.12-.19-.17-.29h0l0-.05h0l-.14-.24h0a.2.2,0,0,0,0-.08l-.12-.27h0l0,0h0l-.12-.3,0-.09c0-.07-.05-.15-.08-.22h0l0-.11a1.46,1.46,0,0,1-.05-.2h0a.74.74,0,0,1,0-.14h0l0-.15h0c0-.07,0-.15,0-.22h0c0-.06,0-.13,0-.2s0-.06,0-.09,0-.21,0-.31,0-.21,0-.31S429.7,253.48,429.71,253.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "439.1 260.61 439.63 260.75 439.86 260.62 440.58 262.46 438.22 263.83 437.35 261.62 439.1 260.61",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "431.32 247.07 429.55 248.1 428.06 246.24 430.43 244.87 431.69 246.44 431.45 246.59 431.32 247.07",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438,260.3l1.14.31-1.75,1A3.74,3.74,0,0,0,438,260.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431,248.24a4.24,4.24,0,0,0-1-.15h-.48l1.77-1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.91,256.7h0c0-.13-.06-.27-.1-.41h0l-.06-.2h0a9.23,9.23,0,0,0-.38-1.12l2.37-1.38a.3.3,0,0,0,0,.1l.06.18.11.3a.14.14,0,0,0,0,.06.83.83,0,0,1,0,.15c0,.11.08.22.11.33l0,.1s0,.07,0,.11.07.27.1.41a.53.53,0,0,1,0,.12.94.94,0,0,1,0,.16L438,257C438,256.89,437.93,256.8,437.91,256.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.34,251.44c-.2-.25-.41-.49-.62-.72l-.06-.07h0l-.24-.24-.1-.1h0l-.43-.4,2.36-1.38c.15.13.29.27.43.41l0,0c.07.07.13.14.2.2l.1.11.33.36h0l.34.42h0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "437.97 256.98 440.34 255.61 442 257.07 439.63 258.45 437.97 256.98",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "439.63 258.45 442 257.07 441.99 259.38 439.86 260.62 439.63 260.75 439.63 258.45",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "433.45 247.74 435.82 246.37 436.25 248.53 433.89 249.91 433.45 247.74",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "431.45 246.59 431.69 246.44 433.81 245.21 435.82 246.37 433.45 247.74 431.45 246.59",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "438.25 253.75 440.61 252.38 439.74 253.59 437.37 254.97 438.25 253.75",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "435.34 251.44 437.7 250.07 437.7 250.07 439.19 249.93 436.83 251.31 435.34 251.44",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "436.83 251.31 439.19 249.93 440.61 252.38 438.25 253.75 436.83 251.31",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.48,255.92l-.87,1.21,1.42,2.45,1.49-.14A11.82,11.82,0,0,0,431,261l.43,2.16,2,1.16.44-1.66a4.2,4.2,0,0,0,1.46.15l.22.27,1.26,1.58,1.43-.81-.87-2.21a3.74,3.74,0,0,0,.61-1.32l1.14.31.53.14v-2.3L438,257c0-.09,0-.18-.06-.28s-.06-.27-.1-.41l-.06-.2a9.23,9.23,0,0,0-.38-1.12l.88-1.22-1.42-2.45-1.49.14c-.2-.25-.41-.49-.62-.72l-.06-.07-.24-.24-.1-.1-.43-.4-.44-2.17-2-1.16-.13.49-.32,1.17a4.24,4.24,0,0,0-1-.15h-.48l-1.49-1.86-1.42.81.72,1.84.14.38a4,4,0,0,0-.61,1.32l-1.66-.46v2.3l1.66,1.47A12.89,12.89,0,0,0,427.48,255.92Zm2.2-2.07c0-.11,0-.21,0-.31s0-.06,0-.1a1.25,1.25,0,0,1,0-.19.3.3,0,0,1,0-.1,1.24,1.24,0,0,0,0-.16l0-.1.06-.14a.41.41,0,0,1,.05-.09l.06-.12.07-.08a.61.61,0,0,1,.07-.1l.07-.07.09-.08.08-.06a1.73,1.73,0,0,1,1.68-.05l.37.18a6.09,6.09,0,0,1,2.74,4.75,2.34,2.34,0,0,1,0,.38,1.75,1.75,0,0,1-.78,1.39h0l-.18.08-.05,0-.15,0h-.05l-.2,0h-.3l-.14,0-.12,0-.12,0-.19-.06-.14-.06a3.07,3.07,0,0,1-.31-.16,2.26,2.26,0,0,1-.26-.16l-.08-.06-.09-.06-.27-.23-.07-.06-.09-.08-.12-.12-.18-.19-.1-.12-.11-.13a1,1,0,0,0-.13-.16l-.07-.11-.14-.19a.56.56,0,0,0,0-.08c-.06-.1-.12-.19-.17-.29l0-.05-.14-.24a.2.2,0,0,0,0-.08l-.12-.27,0,0-.12-.3,0-.09c0-.07-.05-.15-.08-.22l0-.11a1.46,1.46,0,0,1-.05-.2.74.74,0,0,1,0-.14l0-.15c0-.07,0-.15,0-.22s0-.13,0-.2S429.68,254,429.68,253.85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.31,262.79l.22.27-2.12,1.24.44-1.66A4.2,4.2,0,0,0,435.31,262.79Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.89,250.59l-1.66-.46,2.13-1.24.14.38A4,4,0,0,0,426.89,250.59Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.71,253.44a1.25,1.25,0,0,1,0-.19.3.3,0,0,1,0-.1,1.24,1.24,0,0,0,0-.16l0-.1.06-.14a.41.41,0,0,1,.05-.09l.06-.12.07-.08a.61.61,0,0,1,.07-.1l.07-.07.09-.08.08-.06a1.73,1.73,0,0,1,1.68-.05,2.34,2.34,0,0,0,0,.38c0,.1,0,.2,0,.3a.38.38,0,0,1,0,.1l0,.2a2.07,2.07,0,0,0,0,.22.8.8,0,0,0,0,.15l0,.14c0,.06,0,.13.05.19a.56.56,0,0,0,0,.12c0,.07,0,.14.07.22l0,.09.12.3,0,0,.13.26,0,.09.13.24,0,.05a2.61,2.61,0,0,0,.17.28l.06.08.13.2.08.1.12.16.11.13.1.12.19.2a1.14,1.14,0,0,0,.11.11l.1.09.15.13a.39.39,0,0,0,.1.08,1.09,1.09,0,0,0,.17.13l.08.06.26.17.25.13.07,0,0,0a1.75,1.75,0,0,1-.78,1.39h0l-.18.08,0,0h0l-.15,0h-.05l-.2,0h-.3l-.14,0-.11,0h0l-.12,0-.19-.06h0l-.14-.06-.06,0-.25-.13a2.26,2.26,0,0,1-.26-.16l-.08-.06-.09-.06-.09-.07-.09-.08-.09-.08-.07-.06-.09-.08-.12-.12-.18-.19-.1-.12h0l-.11-.13h0a1,1,0,0,0-.13-.16h0l-.07-.11h0l-.14-.19h0a.56.56,0,0,0,0-.08h0c-.06-.1-.12-.19-.17-.29h0l0-.05h0l-.14-.24h0a.2.2,0,0,0,0-.08l-.12-.27h0l0,0h0l-.12-.3,0-.09c0-.07-.05-.15-.08-.22h0l0-.11a1.46,1.46,0,0,1-.05-.2h0a.74.74,0,0,1,0-.14h0l0-.15h0c0-.07,0-.15,0-.22h0c0-.06,0-.13,0-.2s0-.06,0-.09,0-.21,0-.31,0-.21,0-.31S429.7,253.48,429.71,253.44Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "439.1 260.61 439.63 260.75 439.86 260.62 440.58 262.46 438.22 263.83 437.35 261.62 439.1 260.61",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438,260.3l1.14.31-1.75,1A3.74,3.74,0,0,0,438,260.3Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431,248.24a4.24,4.24,0,0,0-1-.15h-.48l1.77-1Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.91,256.7h0c0-.13-.06-.27-.1-.41h0l-.06-.2h0a9.23,9.23,0,0,0-.38-1.12l2.37-1.38a.3.3,0,0,0,0,.1l.06.18.11.3a.14.14,0,0,0,0,.06.83.83,0,0,1,0,.15c0,.11.08.22.11.33l0,.1s0,.07,0,.11.07.27.1.41a.53.53,0,0,1,0,.12.94.94,0,0,1,0,.16L438,257C438,256.89,437.93,256.8,437.91,256.7Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "439.63 258.45 442 257.07 441.99 259.38 439.86 260.62 439.63 260.75 439.63 258.45",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "433.45 247.74 435.82 246.37 436.25 248.53 433.89 249.91 433.45 247.74",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "438.25 253.75 440.61 252.38 439.74 253.59 437.37 254.97 438.25 253.75",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "435.34 251.44 437.7 250.07 437.7 250.07 439.19 249.93 436.83 251.31 435.34 251.44",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "431.32 247.07 429.55 248.1 428.06 246.24 430.43 244.87 431.69 246.44 431.45 246.59 431.32 247.07",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.34,251.44c-.2-.25-.41-.49-.62-.72l-.06-.07h0l-.24-.24-.1-.1h0l-.43-.4,2.36-1.38c.15.13.29.27.43.41l0,0c.07.07.13.14.2.2l.1.11.33.36h0l.34.42h0Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "437.97 256.98 440.34 255.61 442 257.07 439.63 258.45 437.97 256.98",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "431.45 246.59 431.69 246.44 433.81 245.21 435.82 246.37 433.45 247.74 431.45 246.59",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "436.83 251.31 439.19 249.93 440.61 252.38 438.25 253.75 436.83 251.31",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M360.55,298c-7,4.85-14.85,8.21-20.69,14.71-10.89,12.15-11.15,31.69-2.59,45.59s24.48,22.24,40.68,24.15c17,2,34.85-2.69,48.19-13.42S448,341.5,448,324.37s-8.77-34.17-23.11-43.52c-13.09-8.53-31.89-11-45-1.2-6.63,4.93-11.06,12.22-17.68,17.17Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.55,298c-7,4.85-14.85,8.21-20.69,14.71-10.89,12.15-11.15,31.69-2.59,45.59s24.48,22.24,40.68,24.15c17,2,34.85-2.69,48.19-13.42S448,341.5,448,324.37s-8.77-34.17-23.11-43.52c-13.09-8.53-31.89-11-45-1.2-6.63,4.93-11.06,12.22-17.68,17.17Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.4,369.15c0-.12,0-.23.05-.35a18.38,18.38,0,0,1,14.9-15.32,58.22,58.22,0,0,0,19.08-7.31c4.17-2.52,8.12-5.61,12.79-7A20.86,20.86,0,0,1,424,340,16,16,0,0,0,408,335.91c3.73-5.71,7-11.86,8.29-18.55s.38-14.05-3.66-19.54a19.65,19.65,0,0,0-30.35-1.62c-4,4.37-6.25,10.53-8.88,15.84-1.88,3.82-3.83,7.72-6.94,10.63-4.69,4.39-11.44,6-16.3,10.17-5.52,4.75-7.9,12.36-7.92,19.65A57.94,57.94,0,0,0,344.32,367a55.44,55.44,0,0,0,19.95,12.2A21.58,21.58,0,0,1,363.4,369.15Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.84,322a50,50,0,0,0-42.63-48.51,35.39,35.39,0,0,0-4.82.81,48.7,48.7,0,0,1,46.13,47.73c.31,15.93-7.48,32.18-20.85,43.45-10.48,8.83-24.4,14.69-39.69,16.8l1,.12c1.38.16,2.76.28,4.14.35,13.59-2.63,25.9-8.23,35.43-16.27C431.19,355,439.16,338.35,438.84,322Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.59,363.82a48.92,48.92,0,0,1,.85,7.95l1.89-.71a4.86,4.86,0,0,1,5.24,1.2l.09.09a1.89,1.89,0,0,0,2.62.12h0a1.87,1.87,0,0,0,.65-1.37l.26-8Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.87,393.66c-3.91,4.19-11.12,7.85-16.36,4.28l.59,1.33c5.24,3.57,12.45-.09,16.36-4.28s1.37-7.08,4.9-10.8a12.83,12.83,0,0,0,3-4.52c-.15-.4-.3-.92-.49-1.52a15.94,15.94,0,0,1-3.14,4.71C354.25,386.57,356.79,389.47,352.87,393.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359,373.77a7.56,7.56,0,0,1-1.23-2.85,1.67,1.67,0,0,0-.77-1.17l-.05,1.35a1.87,1.87,0,0,1-.65,1.37,1.89,1.89,0,0,1-2.62-.12l-.09-.09a4.86,4.86,0,0,0-5.24-1.2l-1.92.72a1.47,1.47,0,0,0-1,1.41c.12,5.5-2.44,12.79-5.13,16.79-2.77,1.15-5.16,4.92-3.94,7.68l.12.28c5.24,3.57,12.45-.09,16.36-4.28s1.38-7.09,4.9-10.8a15.94,15.94,0,0,0,3.14-4.71A17.21,17.21,0,0,0,359,373.77Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.32,381.7a.67.67,0,0,0,.62-1.19,7.66,7.66,0,0,0-7.52,0c-.12.44-.24.87-.37,1.29A7.37,7.37,0,0,1,351.32,381.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.29,378.73a.66.66,0,0,0,.89-.3.67.67,0,0,0-.28-.89,8,8,0,0,0-7.82.07c-.08.44-.17.89-.27,1.34A7.46,7.46,0,0,1,352.29,378.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.27,384.65a.66.66,0,0,0,.61-1.18,7.62,7.62,0,0,0-7.36-.08c-.16.47-.34.92-.52,1.37A7.37,7.37,0,0,1,350.27,384.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.33,390c-2.77,1.15-5.16,4.92-3.94,7.68l.12.28c5.16,3.52,12.23,0,16.18-4.09C349.39,387.38,342.5,389,340.33,390Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.11,387.54a.68.68,0,0,0,.89-.3.67.67,0,0,0-.28-.89,7.64,7.64,0,0,0-7.37-.07c-.23.52-.48,1-.72,1.48A7.43,7.43,0,0,1,349.11,387.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.36,379.78a48.1,48.1,0,0,1-2.43,7.62l2,.11a4.89,4.89,0,0,1,4.32,3.21l0,.13a1.9,1.9,0,0,0,2.35,1.16h0a1.85,1.85,0,0,0,1.15-1l3.47-7.24Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332,410c-5.27,2.25-13.34,2.69-16.69-2.7v1.46c3.35,5.38,11.42,4.94,16.69,2.69s4.12-5.93,8.84-7.91a12.72,12.72,0,0,0,4.61-2.91c0-.42.09-1,.17-1.58a16.29,16.29,0,0,1-4.78,3C336.1,404.1,337.25,407.77,332,410Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.6,394.29a7.66,7.66,0,0,1,0-3.1,1.64,1.64,0,0,0-.24-1.38L344.8,391a1.9,1.9,0,0,1-3.5-.17l0-.13a4.89,4.89,0,0,0-4.32-3.21l-2-.11a1.47,1.47,0,0,0-1.44.91c-2.11,5.07-7.4,10.71-11.47,13.29-3-.07-6.7,2.41-6.7,5.43v.3c3.35,5.39,11.42,4.95,16.69,2.7s4.12-5.93,8.84-7.91a16.29,16.29,0,0,0,4.78-3A17.67,17.67,0,0,0,345.6,394.29Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.39,398.46a.67.67,0,0,0,.94.08.66.66,0,0,0,.1-.92,7.64,7.64,0,0,0-6.88-3c-.28.35-.57.7-.86,1A7.37,7.37,0,0,1,335.39,398.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.47,396.13a.67.67,0,0,0,.94.08.66.66,0,0,0,.1-.92,8,8,0,0,0-7.18-3.1c-.25.38-.52.75-.79,1.12A7.44,7.44,0,0,1,337.47,396.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.23,400.73a.67.67,0,0,0,1-.84,7.62,7.62,0,0,0-6.7-3c-.34.35-.68.7-1,1A7.36,7.36,0,0,1,333.23,400.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322,401.6c-3-.07-6.7,2.41-6.7,5.43v.3c3.3,5.31,11.18,4.95,16.45,2.79C331.33,402.88,324.38,401.57,322,401.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331,402.9a.67.67,0,0,0,1-.83,7.62,7.62,0,0,0-6.72-3c-.42.37-.84.73-1.25,1.06A7.45,7.45,0,0,1,331,402.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.33,311.21l-26.39,14.71a13.09,13.09,0,0,0-6.49,13.81l5.12,27.58-4.2,13.34c3.63,4.86,11.95,5.11,11.95,5.11,4.64-9.31,8-13.26,10.68-21.06s4.39-13.18,4.39-13.18l21.91-6a26,26,0,0,0,19-22.09c.37-3.32.39-5.58.39-5.58Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.53,318.63a12.47,12.47,0,0,0,3,8l-18.62,11.65a13.42,13.42,0,0,0-5.7,7.44l-6.59,21.55,5.95-24a10.85,10.85,0,0,1,4.84-6.64L368.55,326C366.79,321.65,368.53,318.63,368.53,318.63Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.63,282.7l-3.7,3.58c-3.79-4.84-8.88-8.12-13.33-14.91-1.29-1.62-1.15-4.86-2-6.51-.69-1.3-1.88-3.25-2.38-4.33a.72.72,0,0,0-1.06-.32c-1.27.92-.6,3.11.06,5.43.78,2.7-3.3-1-3.85-1.59-2.59-2.41-4.82-8.32-6.59-7.73s-.36,3.53-.36,3.53c-1.63.35-1,2.94-1,2.94-1,1.7-.69,4.31,1.28,6.75,1.44,1.76,5.32,4.18,7.33,5.38a6.41,6.41,0,0,1,2.1,2l12.68,18.83a7.68,7.68,0,0,0,11,1.87l6.89-5.15Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.08,266.07c-7-.31-16.55,11.08-21.92,16.45.41,6.56,7.48,10.88,7.48,10.88a154.16,154.16,0,0,0,14.44-11.29Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.08,266.07c-7-.31-16.55,11.08-21.92,16.45.41,6.56,7.48,10.88,7.48,10.88a154.16,154.16,0,0,0,14.44-11.29Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.1,319.92c-4.68,4.5-27.16,5.32-38.63-5.6,1.1-7.71.73-16,0-24.13s-5.51-22.46,3.61-24.12c12.17-2.38,20.13-2.19,28.26,2.4C407,282.94,405.84,304.59,405.1,319.92Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.1,319.92c-4.68,4.5-27.16,5.32-38.63-5.6,1.1-7.71.73-16,0-24.13s-5.51-22.46,3.61-24.12c12.17-2.38,20.13-2.19,28.26,2.4C407,282.94,405.84,304.59,405.1,319.92Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.1,319.92c-4.68,4.5-27.16,5.32-38.63-5.6,1.1-7.71.73-16,0-24.13s-5.51-22.46,3.61-24.12c12.17-2.38,20.13-2.19,28.26,2.4C407,282.94,405.84,304.59,405.1,319.92Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.52,247.68a3.32,3.32,0,0,0-1.63-1.71,2.5,2.5,0,0,0-.48-.18,3,3,0,0,0-2.71.91,5.24,5.24,0,0,0-1.32,2.62,22.52,22.52,0,0,0-.33,3,35.28,35.28,0,0,1-.81,5.21,6.63,6.63,0,0,1-3.38,4.41l-.11.06a20.55,20.55,0,0,1-7.88,2.1v3c-2.17,2.95-2.78,8.61,2.95,6.92s9.45-5.5,9.45-9.25c0-1.58.08-3.61.12-5.42.05-2.45.1-4.49.1-4.49a3.22,3.22,0,0,0,2.09,1.09,2.69,2.69,0,0,0,1.1-.06,4.11,4.11,0,0,0,2.45-2.09,7.72,7.72,0,0,0,.78-3.18A6.43,6.43,0,0,0,392.52,247.68Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.66,237.34a7.06,7.06,0,0,0-4.5-2.39l-23.52,2.18c-2.72,5.75-.55,9.55-.55,9.55-.37,8.77-.67,14.34,3.19,16.18a18,18,0,0,0,8.59,1.2,20.55,20.55,0,0,0,7.88-2.1l.12-.06a6.66,6.66,0,0,0,3.37-4.43,35,35,0,0,0,.81-5.19,22.52,22.52,0,0,1,.33-3,5.24,5.24,0,0,1,1.32-2.62,3,3,0,0,1,2.71-.91,2.5,2.5,0,0,1,.48.18C391.56,242.08,391.76,238.7,390.66,237.34Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.05,238a8.07,8.07,0,0,0,.31,4.92,35.82,35.82,0,0,1,1.49,4.79,7.79,7.79,0,0,1-.64,4.83,5.69,5.69,0,0,1-3.75,3c-2.53.54-5-.93-7.53-1.43a10.54,10.54,0,0,0-7.08,1.26,1.23,1.23,0,0,1-1.85-1c-.3-5-.3-12.95.45-16.67Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.85,233.44l-2.93-2a6.21,6.21,0,0,0,1.12,5.75,9.33,9.33,0,0,0,5.15,3,19.6,19.6,0,0,0,6.07.27,44.91,44.91,0,0,0,8.75-1.59,7.12,7.12,0,0,0,3.44-1.81,4.56,4.56,0,0,0,.18-5.36,6.82,6.82,0,0,0-4.84-2.8,18.47,18.47,0,0,0-5.82.46,17.61,17.61,0,0,1-5.82.42,6.08,6.08,0,0,1-4.69-3.11C362.81,229.35,363.85,233.44,363.85,233.44Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "371.23 246.96 366.94 252.15 370.87 253.54 371.23 246.96",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.47,256.12l-3.31,1a2,2,0,0,0,2.23,1A1.85,1.85,0,0,0,374.47,256.12Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.47,256.12l-3.31,1a2,2,0,0,0,2.23,1A1.85,1.85,0,0,0,374.47,256.12Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.31,258.1a1.91,1.91,0,0,0,1.08.07,1.66,1.66,0,0,0,1.08-1.5,2,2,0,0,0-1.28.23A2,2,0,0,0,372.31,258.1Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.06,248.09a1.18,1.18,0,1,1-1.11-1.24A1.18,1.18,0,0,1,377.06,248.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.2,247.18a1.18,1.18,0,1,1-1.11-1.24A1.18,1.18,0,0,1,367.2,247.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.31,242.44l-2.71,1.66a1.7,1.7,0,0,1,.61-1.82A2,2,0,0,1,366.31,242.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.39,242.84l2.51,1.94a1.65,1.65,0,0,0-.41-1.87A2,2,0,0,0,376.39,242.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.33,261.8A7.39,7.39,0,0,0,384.7,259a6.59,6.59,0,0,1-2.84,2.95l-.11.06a20.55,20.55,0,0,1-7.88,2.1v2a19.85,19.85,0,0,0,4.65-1A10.51,10.51,0,0,0,383.33,261.8Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387,329.61a1,1,0,0,1,0,.35,0,0,0,0,0,0,0,1.16,1.16,0,0,1-.14.27,0,0,0,0,1,0,0,1.45,1.45,0,0,1-.24.26v0a2.53,2.53,0,0,1-.36.25l-19.31,11.23a4.56,4.56,0,0,1-.55.24l-.22.06-.28.07a2,2,0,0,1-.34.06h-.08l-.48,0h-.07a3.71,3.71,0,0,1-.47,0h-.07l-.45-.08-.08,0a2.91,2.91,0,0,1-.39-.12l-.07,0-.43-.2L331,323.65a2.07,2.07,0,0,1-.36-.25l-.1-.1a1.46,1.46,0,0,1-.16-.19s0-.08-.07-.12a1.51,1.51,0,0,1-.09-.18s0-.09,0-.13a1.13,1.13,0,0,1,0-.18v1.13a1.13,1.13,0,0,0,0,.18s0,.09,0,.13a1.51,1.51,0,0,0,.09.18s0,.08.07.12a1.46,1.46,0,0,0,.16.19l.1.1a2.07,2.07,0,0,0,.36.25l31.85,18.4.43.2.07,0a2.91,2.91,0,0,0,.39.12l.08,0,.45.08h.07a3.71,3.71,0,0,0,.47,0h.07l.48,0h.08a2,2,0,0,0,.34-.06l.28-.07.22-.06a4.56,4.56,0,0,0,.55-.24L386.15,332a2.53,2.53,0,0,0,.36-.25v0a1.45,1.45,0,0,0,.24-.26,0,0,0,0,0,0,0,1.16,1.16,0,0,0,.14-.27,0,0,0,0,1,0,0,1.06,1.06,0,0,0,0-.25h0v-1.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387,329.61a1,1,0,0,1,0,.35,0,0,0,0,0,0,0,1.16,1.16,0,0,1-.14.27,0,0,0,0,1,0,0,1.45,1.45,0,0,1-.24.26v0a2.53,2.53,0,0,1-.36.25l-19.31,11.23a4.56,4.56,0,0,1-.55.24l-.22.06-.28.07a2,2,0,0,1-.34.06h-.08l-.48,0h-.07a3.71,3.71,0,0,1-.47,0h-.07l-.45-.08-.08,0a2.91,2.91,0,0,1-.39-.12l-.07,0-.43-.2L331,323.65a2.07,2.07,0,0,1-.36-.25l-.1-.1a1.46,1.46,0,0,1-.16-.19s0-.08-.07-.12a1.51,1.51,0,0,1-.09-.18s0-.09,0-.13a1.13,1.13,0,0,1,0-.18v1.13a1.13,1.13,0,0,0,0,.18s0,.09,0,.13a1.51,1.51,0,0,0,.09.18s0,.08.07.12a1.46,1.46,0,0,0,.16.19l.1.1a2.07,2.07,0,0,0,.36.25l31.85,18.4.43.2.07,0a2.91,2.91,0,0,0,.39.12l.08,0,.45.08h.07a3.71,3.71,0,0,0,.47,0h.07l.48,0h.08a2,2,0,0,0,.34-.06l.28-.07.22-.06a4.56,4.56,0,0,0,.55-.24L386.15,332a2.53,2.53,0,0,0,.36-.25v0a1.45,1.45,0,0,0,.24-.26,0,0,0,0,0,0,0,1.16,1.16,0,0,0,.14-.27,0,0,0,0,1,0,0,1.06,1.06,0,0,0,0-.25h0v-1.22Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.23,322.81a1.51,1.51,0,0,0,.09.18s0,.08.07.12a1.46,1.46,0,0,0,.16.19l.1.1a2.07,2.07,0,0,0,.36.25l31.85,18.4.43.2.07,0a2.91,2.91,0,0,0,.39.12l.08,0,.45.08h.07a3.71,3.71,0,0,0,.47,0h.07l.48,0h.08a2,2,0,0,0,.34-.06l.28-.07.22-.06a4.56,4.56,0,0,0,.55-.24l19.31-11.23a2.53,2.53,0,0,0,.36-.25v0a1.45,1.45,0,0,0,.24-.26,0,0,0,0,0,0,0,1.16,1.16,0,0,0,.14-.27,0,0,0,0,1,0,0,1,1,0,0,0,0-.35,1.47,1.47,0,0,0-.82-1.09l-31.86-18.39a4.38,4.38,0,0,0-4,0L331,321.35a1.4,1.4,0,0,0-.82,1.15,1.13,1.13,0,0,0,0,.18S330.22,322.77,330.23,322.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.88,322.5l31,17.87.12.06.06,0,.25.07.17,0h.44a1.89,1.89,0,0,0,.32,0l.2,0,.25-.07a1.45,1.45,0,0,0,.22-.09l9.95-5.79-32-18.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.89,340.58h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.33,317.58,356.51,321a.59.59,0,0,0,0,1l8.71,5a.94.94,0,0,0,1,0l5.82-3.42a.59.59,0,0,0,0-1l-8.71-5A1,1,0,0,0,362.33,317.58Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.88,322.5l31,17.87.12.06.06,0,.25.07.17,0h.44a1.89,1.89,0,0,0,.32,0l.2,0,.25-.07a1.45,1.45,0,0,0,.22-.09l9.95-5.79-32-18.46Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.33,317.58,356.51,321a.59.59,0,0,0,0,1l8.71,5a.94.94,0,0,0,1,0l5.82-3.42a.59.59,0,0,0,0-1l-8.71-5A1,1,0,0,0,362.33,317.58Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.66,340.9l-3.3-21a3.88,3.88,0,0,0-1.88-2.75l-32.07-18.65a1,1,0,0,0-.86,0h0l-.76.38.26.09a1,1,0,0,0-.09.57l3.3,21a3.88,3.88,0,0,0,1.88,2.75l32.08,18.65a.9.9,0,0,0,.21.08l0,.31.74-.36h0A1,1,0,0,0,364.66,340.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.66,340.9l-3.3-21a3.88,3.88,0,0,0-1.88-2.75l-32.07-18.65a1,1,0,0,0-.86,0h0l-.76.38.26.09a1,1,0,0,0-.09.57l3.3,21a3.88,3.88,0,0,0,1.88,2.75l32.08,18.65a.9.9,0,0,0,.21.08l0,.31.74-.36h0A1,1,0,0,0,364.66,340.9Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.84,317.51l-32.08-18.65a1,1,0,0,0-1.44,1l3.3,21a3.86,3.86,0,0,0,1.87,2.74l32.08,18.65a1,1,0,0,0,1.45-1l-3.3-21A3.84,3.84,0,0,0,358.84,317.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.29,318.05a7.09,7.09,0,0,1,3.19,4.59c.2,1.63-.88,2.24-2.43,1.34a7.09,7.09,0,0,1-3.18-4.58C340.66,317.76,341.75,317.16,343.29,318.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.93,294.39l2.89,9.92-17.7,12.57-5.95,2.51a9.25,9.25,0,0,0-3.94,3.14l-4.86,6.71c-.54,1.13,2,3,3.2,3.27h0a4.36,4.36,0,0,0,4-1l3.74-3.44,1-.36a15.7,15.7,0,0,0,7.52-5.65h0L407.65,314a8,8,0,0,0,4.8-9.47L409,291.74Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392,281.08l5.13,15.35c8.35.57,12.24-2.24,13.39-4.72-4.38-19.93-7.27-23.24-13-23.66S392,281.08,392,281.08Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392,281.08l5.13,15.35c8.35.57,12.24-2.24,13.39-4.72-4.38-19.93-7.27-23.24-13-23.66S392,281.08,392,281.08Z",
    style: {
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326,307.27l-.09,0,.08.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195,436.27c-.61,1.28-2.55,2.47-4.67,2.82a21.28,21.28,0,0,1-6.4-.41,42.46,42.46,0,0,0-9.56-.24,51.58,51.58,0,0,1-5.95.42,9.46,9.46,0,0,1-5.59-1.77,5.75,5.75,0,0,1-2.1-3.57,5.39,5.39,0,0,0,2.1,4.81,9.47,9.47,0,0,0,5.59,1.78,51.59,51.59,0,0,0,5.95-.43,41.88,41.88,0,0,1,9.56.25c2.13.29,4.43.9,6.55.55s4.06-1.53,4.67-2.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.78,432.49c1.78,0,1.13-2.64,2.82-4.4-.69,0-1.38.05-2.07,0C171,430.33,170.57,432.49,171.78,432.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.48,432.35c1.8,0,1.33-3.14,3.09-5-.4.14-.81.26-1.22.36l-1.06.19C174.72,430.14,174.26,432.35,175.48,432.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.14,426.32a2.52,2.52,0,0,0-.93-1.45l-9.64-.24a8.18,8.18,0,0,1-4,2.74c-1.76,1.84-1.29,5-3.09,5-1.22,0-.76-2.21.81-4.43-.56.08-1.12.13-1.69.17-1.69,1.76-1,4.4-2.82,4.4-1.21,0-.78-2.16.75-4.36h-1.35c-.41,0-.82,0-1.24-.07-3.54,2.81-3.84,5.85-3.38,10.62a12.76,12.76,0,0,0,1.84.19,51.58,51.58,0,0,0,5.95-.42,42.46,42.46,0,0,1,9.56.24,21.28,21.28,0,0,0,6.4.41c2.12-.35,4.06-1.54,4.67-2.82Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.94,428.05a15.22,15.22,0,0,0-4.81,0,5.74,5.74,0,0,0-4.34,3.78,4.2,4.2,0,0,0-.08,1.69,5.75,5.75,0,0,0,2.1,3.57,8.35,8.35,0,0,0,3.75,1.58C166.1,433.9,166.4,430.86,169.94,428.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.3,421.89v4.64a1.91,1.91,0,0,0,1.9,1.91h4.86a3.13,3.13,0,0,0,3.13-3l.12-3.52Z",
    style: {
      fill: "#995c5c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.41,419.82a3.59,3.59,0,0,1-2.92,2.05,6.16,6.16,0,0,1-3.7-.91c-1.67-1.06-2.33-2.74-3.47-4.24a25,25,0,0,0-4-3.94,13.27,13.27,0,0,1-3.85-4.46,5.7,5.7,0,0,1-.45-1.64,5.84,5.84,0,0,0,.45,3.14,13.4,13.4,0,0,0,3.85,4.47,25,25,0,0,1,4,3.93c1.14,1.51,1.8,3.18,3.47,4.24a6.16,6.16,0,0,0,3.7.91,3.55,3.55,0,0,0,2.92-2.05,8,8,0,0,0,.18-2.58A3.38,3.38,0,0,1,214.41,419.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.46,409.63a1.16,1.16,0,0,0-.23.79.81.81,0,0,0,.52.6,1.17,1.17,0,0,0,1.09-.28,5.8,5.8,0,0,0,.75-.89,5.66,5.66,0,0,1,2.48-1.81,5.3,5.3,0,0,1,1.48-.33l-1.2-1.1a6.19,6.19,0,0,0-2.2.54A6.09,6.09,0,0,0,203.46,409.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.72,405.8a6,6,0,0,0-2.69,2.48,1.16,1.16,0,0,0-.23.79.81.81,0,0,0,.52.6,1.17,1.17,0,0,0,1.09-.28,5.43,5.43,0,0,0,.75-.9,5.66,5.66,0,0,1,4.91-2.13l-1.19-1.08A6,6,0,0,0,203.72,405.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.12,404.59a12.73,12.73,0,0,0-3.78-2.53,5,5,0,0,0-5.2.72,4.47,4.47,0,0,0-1.15,3.9,5.7,5.7,0,0,0,.45,1.64,8.29,8.29,0,0,0,1.2,1.89C198.1,406.06,201.7,404.12,206.12,404.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.51,415.75a8.67,8.67,0,0,0-.95-4.06l-2.34-2.46-1.67-1.52a5.3,5.3,0,0,0-1.48.33,5.66,5.66,0,0,0-2.48,1.81,5.8,5.8,0,0,1-.75.89,1.17,1.17,0,0,1-1.09.28.81.81,0,0,1-.52-.6,1.16,1.16,0,0,1,.23-.79,6.09,6.09,0,0,1,2.69-2.48,6.19,6.19,0,0,1,2.2-.54l-.28-.25a5.66,5.66,0,0,0-4.91,2.13,5.43,5.43,0,0,1-.75.9,1.17,1.17,0,0,1-1.09.28.81.81,0,0,1-.52-.6,1.16,1.16,0,0,1,.23-.79,6,6,0,0,1,5.85-3l0,0-.72-.65c-4.42-.47-8,1.47-8.48,5.62a19.52,19.52,0,0,0,2.65,2.57,25,25,0,0,1,4,3.94c1.14,1.5,1.8,3.18,3.47,4.24a6.16,6.16,0,0,0,3.7.91,3.59,3.59,0,0,0,2.92-2.05,3.38,3.38,0,0,0,.18-1.08A29.63,29.63,0,0,0,214.51,415.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.05,408.41l.28,5c3.14,1.82,6.45.83,7.55-.32l.21-4.66Z",
    style: {
      fill: "#995c5c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.25,300.7a4.42,4.42,0,0,1-.48-1.71l-.27-4.28-30.47,2c-.4,2.14-.81,4.75-1.21,7.72A45.35,45.35,0,0,0,212.25,300.7Z",
    style: {
      fill: "#995c5c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.65,283.45,218.14,296l-5.89,9.87,6.52,10.31,9.84-15.28a8.61,8.61,0,0,0,1-7.06,120.67,120.67,0,0,0-6.4-17.41Z",
    style: {
      fill: "#995c5c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.49,259.22c7.47-1.39,11.74,1.1,18.06,18C222,283,211,285.14,211,285.14Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.5,261.21l-8.15,1.6c-1.8,3.3-3.64,6.4-5.44,9.7-1.36,2.48-2.76,5.12-2.65,7.95a8.11,8.11,0,0,0,4.88,7l-.94,11.13c12.81,3.92,28.46.48,31.9-2.49,1-4.66,1.9-9.62,2.91-14.29a47.79,47.79,0,0,0,1.38-9.19,16.16,16.16,0,0,0-2.15-8.92l-.05-.08a10,10,0,0,0-10-4.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.72,301.48a4.15,4.15,0,0,1-.47-.78,45.35,45.35,0,0,1-32.43,3.69c-2.3,17.09-4.27,46-3.06,65.14,1,22.23,5.1,53.72,5.1,53.72,5.33,1.6,9.34.62,10.85-.54,1.78-22,5.69-37.17,2.67-51.76,2-10.19,3.32-23,3.32-23l1.54,22.53,5.22,39.6a9.35,9.35,0,0,0,9.36-.47c3.8-22.65,5.22-38,1.9-49.23C221.79,323.21,222,313.7,212.72,301.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.94,343.5l2.8-11.73c3.26-.54,8.36-2.67,11-7.15a22.43,22.43,0,0,1-13.52,4.77L198.7,348l.54,7.93.22-2.88A61,61,0,0,1,200.94,343.5Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.84,247.78,140.05,269a8.49,8.49,0,0,0,6.45,5.29l14,2.45a12.61,12.61,0,0,0,3.1-5.84,12.76,12.76,0,0,0-.61-7.33,66.14,66.14,0,0,1-12.64-1.39s-8.87-10.78-12.57-16.34l2.64-8.75a3,3,0,0,0-.27-2.38l-1.42-2.46a3,3,0,0,0-1.64-1.36l-2.05-.69a3.62,3.62,0,0,0-2.83.21l-3.12,1.63a1.21,1.21,0,0,0-.64,1.08h0a1.22,1.22,0,0,0,.65,1.05l1.17.6,1.61,2.74A8.63,8.63,0,0,0,131.84,247.78Z",
    style: {
      fill: "#995c5c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.08,262.67c-5.05.23-12.63,1.07-20.06.92a12.76,12.76,0,0,1,.61,7.33,12.61,12.61,0,0,1-3.1,5.84l17.52,3.07a7.54,7.54,0,0,0,8.46-5.55c.54-2.22,1.13-4.08,1.46-6.24A4.69,4.69,0,0,0,183.08,262.67Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.57,239.29a14.19,14.19,0,0,1-1.6-7.51,8.12,8.12,0,0,1,3.94-6.35,5.74,5.74,0,0,1,7.05,1.24,13.1,13.1,0,0,1,19.35,12.54c-.18,2.7-1.17,5.35-.86,8,.17,1.58.8,3.18.38,4.72a4.88,4.88,0,0,1-2.56,2.9c-1.18.61-3.94.45-5.24.72-4,3.62-9,2.26-12.14-1S182.57,239.29,182.57,239.29Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "181.75 242.88 179.26 247.2 181.98 248.2 181.75 242.88",
    style: {
      fill: "#804040"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 181.98,
    y1: 248.2,
    x2: 181.74,
    y2: 242.88,
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.46,241c.4-3.79,1.51-7.36,4-9.17a20.45,20.45,0,0,0,2.83,13.55,6,6,0,0,1,1.84-3.25,3.43,3.43,0,0,1,3.53-.75,3.5,3.5,0,0,1,1.77,1.93,4.59,4.59,0,0,1-5.75,6.07,8.84,8.84,0,0,0,6.79,6.88,11.34,11.34,0,0,0,6.58-.63l1,5.11c-4.15,4.43-11.25,1.45-11.25,1.45l-.94-5c-8.16.48-8.93.35-9.83-4.15A44.5,44.5,0,0,1,181.46,241Z",
    style: {
      fill: "#995c5c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.56,235.46a14.33,14.33,0,0,1,6.5-7.77,13.75,13.75,0,0,1,5.25,11.52c-.18,2.7-1.17,5.35-.86,8,.17,1.58.8,3.18.38,4.72a4.88,4.88,0,0,1-2.56,2.9c-1.18.61-3.94.45-5.24.72-.17.16-.34.29-.52.43a39.69,39.69,0,0,1-3.23-8.29A21.18,21.18,0,0,1,199.56,235.46Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.82,232.63a10.41,10.41,0,0,1,19.85-.25c2.46,7.46-3.85,15.39-2.47,23.12.5,2.79,2,5.33,2.48,8.11a12,12,0,0,1-10.37,14.07c1.78-2,1.81-5,.8-7.42s-2.82-4.44-4.37-6.58C201.47,255.08,198.73,242.81,201.82,232.63Z",
    style: {
      fill: "#37474f"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsiteCreator);
export default __webpack_public_path__ + "static/media/Website-Creator.f45a5d71959d2556a4d71c885ac10da6.svg";
export { ForwardRef as ReactComponent };